// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAdminUsersIdData, DeleteAdminUsersIdErrors, DeleteAdminUsersIdResponses, GetAdminUsersIdActivityData, GetAdminUsersIdActivityErrors, GetAdminUsersIdActivityResponses, GetAdminUsersIdSecuritySummaryData, GetAdminUsersIdSecuritySummaryErrors, GetAdminUsersIdSecuritySummaryResponses, GetAdminUsersIdSessionsData, GetAdminUsersIdSessionsErrors, GetAdminUsersIdSessionsResponses, GetApiKeysData, GetApiKeysErrors, GetApiKeysResponses, GetBackofficeAuthExportsIdData, GetBackofficeAuthExportsIdErrors, GetBackofficeAuthExportsIdResponses, GetBillingApiAnalyticsSummaryData, GetBillingApiAnalyticsSummaryErrors, GetBillingApiAnalyticsSummaryResponses, GetBillingApiAnalyticsTimeseriesData, GetBillingApiAnalyticsTimeseriesErrors, GetBillingApiAnalyticsTimeseriesResponses, GetBillingApiRequestLogsData, GetBillingApiRequestLogsErrors, GetBillingApiRequestLogsResponses, GetBillingData, GetBillingErrors, GetBillingResponses, GetBillingUsageData, GetBillingUsageErrors, GetBillingUsageResponses, GetDocsSchemaData, GetDocsSchemaErrors, GetHealthCheckData, GetHealthCheckErrors, GetHealthCheckResponses, GetHealthCheckServicesData, GetHealthCheckServicesErrors, GetLandingMetricsData, GetLandingMetricsErrors, GetLandingMetricsResponses, GetUsersMeData, GetUsersMeErrors, GetUsersMePreferencesData, GetUsersMePreferencesErrors, GetUsersMePreferencesResponses, GetUsersMeResponses, GetUsersMeStatsData, GetUsersMeStatsErrors, GetUsersMeStatsResponses, GetUsersUsernameAvailabilityData, GetUsersUsernameAvailabilityErrors, GetUsersUsernameAvailabilityResponses, GetV1CardsData, GetV1CardsErrors, GetV1CardsIdData, GetV1CardsIdErrors, GetV1CardsIdPricesData, GetV1CardsIdPricesErrors, GetV1CardsIdPricesResponses, GetV1CardsIdResponses, GetV1CardsResponses, GetV1SetsData, GetV1SetsErrors, GetV1SetsIdCardsData, GetV1SetsIdCardsErrors, GetV1SetsIdCardsResponses, GetV1SetsResponses, PatchUsersMeData, PatchUsersMeErrors, PatchUsersMePreferencesData, PatchUsersMePreferencesErrors, PatchUsersMePreferencesResponses, PatchUsersMeResponses, PostAdminUsersExportData, PostAdminUsersExportErrors, PostAdminUsersExportResponses, PostAdminUsersIdBanData, PostAdminUsersIdBanErrors, PostAdminUsersIdBanResponses, PostAdminUsersIdImpersonateData, PostAdminUsersIdImpersonateErrors, PostAdminUsersIdImpersonateResponses, PostAdminUsersIdUnbanData, PostAdminUsersIdUnbanErrors, PostAdminUsersIdUnbanResponses, PostAdminUsersSearchData, PostAdminUsersSearchErrors, PostAdminUsersSearchResponses, PostApiKeysData, PostApiKeysErrors, PostApiKeysIdRevokeData, PostApiKeysIdRevokeErrors, PostApiKeysIdRevokeResponses, PostApiKeysResponses, PostApiKeysRevokeAllData, PostApiKeysRevokeAllErrors, PostApiKeysRevokeAllResponses, PostAppConfigGetStatusData, PostAppConfigGetStatusErrors, PostAppConfigGetStatusResponses, PostAssetsCreateAssetsData, PostAssetsCreateAssetsErrors, PostAssetsCreateAssetsResponses, PostAuthAdoptImpersonationSessionData, PostAuthAdoptImpersonationSessionErrors, PostAuthAdoptImpersonationSessionResponses, PostAuthChangePasswordData, PostAuthChangePasswordErrors, PostAuthChangePasswordResponses, PostAuthConfirmEmailChangeData, PostAuthConfirmEmailChangeErrors, PostAuthConfirmEmailChangeResponses, PostAuthDeletePasskeyData, PostAuthDeletePasskeyErrors, PostAuthDeletePasskeyResponses, PostAuthDeleteTotpAuthenticatorData, PostAuthDeleteTotpAuthenticatorErrors, PostAuthDeleteTotpAuthenticatorResponses, PostAuthDeleteUserData, PostAuthDeleteUserErrors, PostAuthDeleteUserResponses, PostAuthDisableTwoFactorData, PostAuthDisableTwoFactorErrors, PostAuthDisableTwoFactorResponses, PostAuthEnableTwoFactorData, PostAuthEnableTwoFactorErrors, PostAuthEnableTwoFactorResponses, PostAuthGenerateBackupCodesData, PostAuthGenerateBackupCodesErrors, PostAuthGenerateBackupCodesResponses, PostAuthGeneratePasskeyRegisterOptionsData, PostAuthGeneratePasskeyRegisterOptionsErrors, PostAuthGeneratePasskeyRegisterOptionsResponses, PostAuthGeneratePasskeySignInOptionsData, PostAuthGeneratePasskeySignInOptionsErrors, PostAuthGeneratePasskeySignInOptionsResponses, PostAuthGeneratePasskeySignUpOptionsData, PostAuthGeneratePasskeySignUpOptionsErrors, PostAuthGeneratePasskeySignUpOptionsResponses, PostAuthGeneratePasskeyStepUpOptionsData, PostAuthGeneratePasskeyStepUpOptionsErrors, PostAuthGeneratePasskeyStepUpOptionsResponses, PostAuthGetSessionData, PostAuthGetSessionErrors, PostAuthGetSessionResponses, PostAuthGetSocialProvidersData, PostAuthGetSocialProvidersErrors, PostAuthGetSocialProvidersResponses, PostAuthIssueSocialNativeNonceData, PostAuthIssueSocialNativeNonceErrors, PostAuthIssueSocialNativeNonceResponses, PostAuthListPasskeysData, PostAuthListPasskeysErrors, PostAuthListPasskeysResponses, PostAuthListSessionsData, PostAuthListSessionsErrors, PostAuthListSessionsResponses, PostAuthListSocialAccountsData, PostAuthListSocialAccountsErrors, PostAuthListSocialAccountsResponses, PostAuthListTotpAuthenticatorsData, PostAuthListTotpAuthenticatorsErrors, PostAuthListTotpAuthenticatorsResponses, PostAuthRefreshData, PostAuthRefreshErrors, PostAuthRefreshResponses, PostAuthRegisterTotpAuthenticatorData, PostAuthRegisterTotpAuthenticatorErrors, PostAuthRegisterTotpAuthenticatorResponses, PostAuthRequestEmailChangeData, PostAuthRequestEmailChangeErrors, PostAuthRequestEmailChangeResponses, PostAuthRequestPasswordResetData, PostAuthRequestPasswordResetErrors, PostAuthRequestPasswordResetResponses, PostAuthResendEmailChangeOtpData, PostAuthResendEmailChangeOtpErrors, PostAuthResendEmailChangeOtpResponses, PostAuthResendSignupOtpData, PostAuthResendSignupOtpErrors, PostAuthResendSignupOtpResponses, PostAuthResetPasswordData, PostAuthResetPasswordErrors, PostAuthResetPasswordResponses, PostAuthRevokeOtherSessionsData, PostAuthRevokeOtherSessionsErrors, PostAuthRevokeOtherSessionsResponses, PostAuthRevokeSessionData, PostAuthRevokeSessionErrors, PostAuthRevokeSessionResponses, PostAuthSendChangePasswordOtpData, PostAuthSendChangePasswordOtpErrors, PostAuthSendChangePasswordOtpResponses, PostAuthSendDisableTwoFactorOtpData, PostAuthSendDisableTwoFactorOtpErrors, PostAuthSendDisableTwoFactorOtpResponses, PostAuthSendEmailVerificationMagicLinkData, PostAuthSendEmailVerificationMagicLinkErrors, PostAuthSendEmailVerificationMagicLinkResponses, PostAuthSendEmailVerificationOtpData, PostAuthSendEmailVerificationOtpErrors, PostAuthSendEmailVerificationOtpResponses, PostAuthSendSignInMagicLinkData, PostAuthSendSignInMagicLinkErrors, PostAuthSendSignInMagicLinkResponses, PostAuthSendSignInOtpData, PostAuthSendSignInOtpErrors, PostAuthSendSignInOtpResponses, PostAuthSendTwoFactorOtpData, PostAuthSendTwoFactorOtpErrors, PostAuthSendTwoFactorOtpResponses, PostAuthSignInAsGuestData, PostAuthSignInAsGuestErrors, PostAuthSignInAsGuestResponses, PostAuthSignInWithAppleData, PostAuthSignInWithAppleErrors, PostAuthSignInWithAppleMobileOttData, PostAuthSignInWithAppleMobileOttErrors, PostAuthSignInWithAppleMobileOttResponses, PostAuthSignInWithAppleResponses, PostAuthSignInWithEmailData, PostAuthSignInWithEmailErrors, PostAuthSignInWithEmailOtpData, PostAuthSignInWithEmailOtpErrors, PostAuthSignInWithEmailOtpResponses, PostAuthSignInWithEmailResponses, PostAuthSignInWithGoogleData, PostAuthSignInWithGoogleErrors, PostAuthSignInWithGoogleResponses, PostAuthSignInWithMagicLinkData, PostAuthSignInWithMagicLinkErrors, PostAuthSignInWithMagicLinkResponses, PostAuthSignInWithPasskeyData, PostAuthSignInWithPasskeyErrors, PostAuthSignInWithPasskeyResponses, PostAuthSignOutData, PostAuthSignOutErrors, PostAuthSignOutResponses, PostAuthSignUpWithEmailData, PostAuthSignUpWithEmailErrors, PostAuthSignUpWithEmailResponses, PostAuthSignUpWithPasskeyData, PostAuthSignUpWithPasskeyErrors, PostAuthSignUpWithPasskeyResponses, PostAuthStartAppleSignInRedirectData, PostAuthStartAppleSignInRedirectErrors, PostAuthStartAppleSignInRedirectResponses, PostAuthStartGoogleSignInRedirectData, PostAuthStartGoogleSignInRedirectErrors, PostAuthStartGoogleSignInRedirectResponses, PostAuthUnlinkSocialAccountData, PostAuthUnlinkSocialAccountErrors, PostAuthUnlinkSocialAccountResponses, PostAuthUpdatePasskeyData, PostAuthUpdatePasskeyErrors, PostAuthUpdatePasskeyResponses, PostAuthUpdateTotpAuthenticatorData, PostAuthUpdateTotpAuthenticatorErrors, PostAuthUpdateTotpAuthenticatorResponses, PostAuthVerifyBackupCodeData, PostAuthVerifyBackupCodeErrors, PostAuthVerifyBackupCodeResponses, PostAuthVerifyEmailData, PostAuthVerifyEmailErrors, PostAuthVerifyEmailResponses, PostAuthVerifyPasskeyRegistrationData, PostAuthVerifyPasskeyRegistrationErrors, PostAuthVerifyPasskeyRegistrationResponses, PostAuthVerifyTotpData, PostAuthVerifyTotpEnrollmentData, PostAuthVerifyTotpEnrollmentErrors, PostAuthVerifyTotpEnrollmentResponses, PostAuthVerifyTotpErrors, PostAuthVerifyTotpResponses, PostAuthVerifyTwoFactorOtpData, PostAuthVerifyTwoFactorOtpErrors, PostAuthVerifyTwoFactorOtpResponses, PostAuthVerifyTwoFactorPasskeyData, PostAuthVerifyTwoFactorPasskeyErrors, PostAuthVerifyTwoFactorPasskeyResponses, PostBackofficeAuthAcceptInviteData, PostBackofficeAuthAcceptInviteErrors, PostBackofficeAuthAcceptInviteResponses, PostBackofficeAuthChangePasswordData, PostBackofficeAuthChangePasswordErrors, PostBackofficeAuthChangePasswordResponses, PostBackofficeAuthConfirmEmailChangeData, PostBackofficeAuthConfirmEmailChangeErrors, PostBackofficeAuthConfirmEmailChangeResponses, PostBackofficeAuthCreateAdminData, PostBackofficeAuthCreateAdminErrors, PostBackofficeAuthCreateAdminResponses, PostBackofficeAuthCreateAssetsData, PostBackofficeAuthCreateAssetsErrors, PostBackofficeAuthCreateAssetsResponses, PostBackofficeAuthDeleteAdminData, PostBackofficeAuthDeleteAdminErrors, PostBackofficeAuthDeleteAdminResponses, PostBackofficeAuthDeletePasskeyData, PostBackofficeAuthDeletePasskeyErrors, PostBackofficeAuthDeletePasskeyResponses, PostBackofficeAuthDeleteTotpAuthenticatorData, PostBackofficeAuthDeleteTotpAuthenticatorErrors, PostBackofficeAuthDeleteTotpAuthenticatorResponses, PostBackofficeAuthDisableAdminData, PostBackofficeAuthDisableAdminErrors, PostBackofficeAuthDisableAdminResponses, PostBackofficeAuthDisableTwoFactorData, PostBackofficeAuthDisableTwoFactorErrors, PostBackofficeAuthDisableTwoFactorResponses, PostBackofficeAuthEnableAdminData, PostBackofficeAuthEnableAdminErrors, PostBackofficeAuthEnableAdminResponses, PostBackofficeAuthEnableTwoFactorData, PostBackofficeAuthEnableTwoFactorErrors, PostBackofficeAuthEnableTwoFactorResponses, PostBackofficeAuthExportAdminsData, PostBackofficeAuthExportAdminsErrors, PostBackofficeAuthExportAdminsResponses, PostBackofficeAuthGenerateBackupCodesData, PostBackofficeAuthGenerateBackupCodesErrors, PostBackofficeAuthGenerateBackupCodesResponses, PostBackofficeAuthGeneratePasskeyRegisterOptionsData, PostBackofficeAuthGeneratePasskeyRegisterOptionsErrors, PostBackofficeAuthGeneratePasskeyRegisterOptionsResponses, PostBackofficeAuthGeneratePasskeySignInOptionsData, PostBackofficeAuthGeneratePasskeySignInOptionsErrors, PostBackofficeAuthGeneratePasskeySignInOptionsResponses, PostBackofficeAuthGeneratePasskeyStepUpOptionsData, PostBackofficeAuthGeneratePasskeyStepUpOptionsErrors, PostBackofficeAuthGeneratePasskeyStepUpOptionsResponses, PostBackofficeAuthGetMeData, PostBackofficeAuthGetMeErrors, PostBackofficeAuthGetMeResponses, PostBackofficeAuthGetSessionData, PostBackofficeAuthGetSessionErrors, PostBackofficeAuthGetSessionResponses, PostBackofficeAuthGetSocialProvidersData, PostBackofficeAuthGetSocialProvidersErrors, PostBackofficeAuthGetSocialProvidersResponses, PostBackofficeAuthIssueSocialNativeNonceData, PostBackofficeAuthIssueSocialNativeNonceErrors, PostBackofficeAuthIssueSocialNativeNonceResponses, PostBackofficeAuthListAdminsData, PostBackofficeAuthListAdminsErrors, PostBackofficeAuthListAdminsResponses, PostBackofficeAuthListPasskeysData, PostBackofficeAuthListPasskeysErrors, PostBackofficeAuthListPasskeysResponses, PostBackofficeAuthListSessionsData, PostBackofficeAuthListSessionsErrors, PostBackofficeAuthListSessionsResponses, PostBackofficeAuthListSocialAccountsData, PostBackofficeAuthListSocialAccountsErrors, PostBackofficeAuthListSocialAccountsResponses, PostBackofficeAuthListTotpAuthenticatorsData, PostBackofficeAuthListTotpAuthenticatorsErrors, PostBackofficeAuthListTotpAuthenticatorsResponses, PostBackofficeAuthRegisterTotpAuthenticatorData, PostBackofficeAuthRegisterTotpAuthenticatorErrors, PostBackofficeAuthRegisterTotpAuthenticatorResponses, PostBackofficeAuthRequestEmailChangeData, PostBackofficeAuthRequestEmailChangeErrors, PostBackofficeAuthRequestEmailChangeResponses, PostBackofficeAuthRequestPasswordResetData, PostBackofficeAuthRequestPasswordResetErrors, PostBackofficeAuthRequestPasswordResetResponses, PostBackofficeAuthResendInviteData, PostBackofficeAuthResendInviteErrors, PostBackofficeAuthResendInviteResponses, PostBackofficeAuthResetPasswordData, PostBackofficeAuthResetPasswordErrors, PostBackofficeAuthResetPasswordResponses, PostBackofficeAuthRevokeSessionData, PostBackofficeAuthRevokeSessionErrors, PostBackofficeAuthRevokeSessionResponses, PostBackofficeAuthSendChangePasswordOtpData, PostBackofficeAuthSendChangePasswordOtpErrors, PostBackofficeAuthSendChangePasswordOtpResponses, PostBackofficeAuthSendDisableTwoFactorOtpData, PostBackofficeAuthSendDisableTwoFactorOtpErrors, PostBackofficeAuthSendDisableTwoFactorOtpResponses, PostBackofficeAuthSendSignInOtpData, PostBackofficeAuthSendSignInOtpErrors, PostBackofficeAuthSendSignInOtpResponses, PostBackofficeAuthSendTwoFactorOtpData, PostBackofficeAuthSendTwoFactorOtpErrors, PostBackofficeAuthSendTwoFactorOtpResponses, PostBackofficeAuthSignInWithAppleData, PostBackofficeAuthSignInWithAppleErrors, PostBackofficeAuthSignInWithAppleMobileOttData, PostBackofficeAuthSignInWithAppleMobileOttErrors, PostBackofficeAuthSignInWithAppleMobileOttResponses, PostBackofficeAuthSignInWithAppleResponses, PostBackofficeAuthSignInWithEmailData, PostBackofficeAuthSignInWithEmailErrors, PostBackofficeAuthSignInWithEmailOtpData, PostBackofficeAuthSignInWithEmailOtpErrors, PostBackofficeAuthSignInWithEmailOtpResponses, PostBackofficeAuthSignInWithEmailResponses, PostBackofficeAuthSignInWithGoogleData, PostBackofficeAuthSignInWithGoogleErrors, PostBackofficeAuthSignInWithGoogleResponses, PostBackofficeAuthSignInWithPasskeyData, PostBackofficeAuthSignInWithPasskeyErrors, PostBackofficeAuthSignInWithPasskeyResponses, PostBackofficeAuthSignOutData, PostBackofficeAuthSignOutErrors, PostBackofficeAuthSignOutResponses, PostBackofficeAuthStartAppleSignInRedirectData, PostBackofficeAuthStartAppleSignInRedirectErrors, PostBackofficeAuthStartAppleSignInRedirectResponses, PostBackofficeAuthStartGoogleSignInRedirectData, PostBackofficeAuthStartGoogleSignInRedirectErrors, PostBackofficeAuthStartGoogleSignInRedirectResponses, PostBackofficeAuthUnlinkSocialAccountData, PostBackofficeAuthUnlinkSocialAccountErrors, PostBackofficeAuthUnlinkSocialAccountResponses, PostBackofficeAuthUpdateAdminAbilitiesData, PostBackofficeAuthUpdateAdminAbilitiesErrors, PostBackofficeAuthUpdateAdminAbilitiesResponses, PostBackofficeAuthUpdateMeData, PostBackofficeAuthUpdateMeErrors, PostBackofficeAuthUpdateMePreferencesData, PostBackofficeAuthUpdateMePreferencesErrors, PostBackofficeAuthUpdateMePreferencesResponses, PostBackofficeAuthUpdateMeResponses, PostBackofficeAuthUpdatePasskeyData, PostBackofficeAuthUpdatePasskeyErrors, PostBackofficeAuthUpdatePasskeyResponses, PostBackofficeAuthUpdateTotpAuthenticatorData, PostBackofficeAuthUpdateTotpAuthenticatorErrors, PostBackofficeAuthUpdateTotpAuthenticatorResponses, PostBackofficeAuthVerifyBackupCodeData, PostBackofficeAuthVerifyBackupCodeErrors, PostBackofficeAuthVerifyBackupCodeResponses, PostBackofficeAuthVerifyPasskeyRegistrationData, PostBackofficeAuthVerifyPasskeyRegistrationErrors, PostBackofficeAuthVerifyPasskeyRegistrationResponses, PostBackofficeAuthVerifyTotpData, PostBackofficeAuthVerifyTotpEnrollmentData, PostBackofficeAuthVerifyTotpEnrollmentErrors, PostBackofficeAuthVerifyTotpEnrollmentResponses, PostBackofficeAuthVerifyTotpErrors, PostBackofficeAuthVerifyTotpResponses, PostBackofficeAuthVerifyTwoFactorOtpData, PostBackofficeAuthVerifyTwoFactorOtpErrors, PostBackofficeAuthVerifyTwoFactorOtpResponses, PostBackofficeAuthVerifyTwoFactorPasskeyData, PostBackofficeAuthVerifyTwoFactorPasskeyErrors, PostBackofficeAuthVerifyTwoFactorPasskeyResponses, PostBillingCheckoutSessionData, PostBillingCheckoutSessionErrors, PostBillingCheckoutSessionResponses, PostBillingPortalSessionData, PostBillingPortalSessionErrors, PostBillingPortalSessionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Schema
 *
 * Returns the OpenAPI JSON schema
 */
export const getDocsSchema = <ThrowOnError extends boolean = true>(options?: Options<GetDocsSchemaData, ThrowOnError>) => (options?.client ?? client).get<unknown, GetDocsSchemaErrors, ThrowOnError>({ url: '/docs/schema', ...options });

/**
 * Users :id Ban
 *
 * Ban the user identified by the `id` path parameter, recording an optional `reason` and an optional `expiresAt` after which the ban lifts on its own. Requires an authenticated admin with the `users.manage` ability. The banned user is signed out everywhere immediately and cannot sign in while the ban holds; returns 404 if no user matches the id. Use `POST /admin/users/:id/unban` to lift a ban early.
 */
export const postAdminUsersIdBan = <ThrowOnError extends boolean = true>(options: Options<PostAdminUsersIdBanData, ThrowOnError>) => (options.client ?? client).post<PostAdminUsersIdBanResponses, PostAdminUsersIdBanErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}/ban',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users :id Unban
 *
 * Lift any ban on the user identified by the `id` path parameter, clearing the ban reason and expiry so the user can sign in again. Requires an authenticated admin with the `users.manage` ability. Returns 404 if no user matches the id; calling it on a user who is not banned succeeds and leaves them unbanned.
 */
export const postAdminUsersIdUnban = <ThrowOnError extends boolean = true>(options: Options<PostAdminUsersIdUnbanData, ThrowOnError>) => (options.client ?? client).post<PostAdminUsersIdUnbanResponses, PostAdminUsersIdUnbanErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}/unban',
    ...options
});

/**
 * Users :id
 *
 * Permanently closes the account identified by the `id` path parameter: it can no longer sign in and every active session is ended immediately, while the email, passkeys, and linked social identities are released so they can be reused for a brand-new sign-up. Requires an authenticated admin with the `users.manage` ability. A `reason` is required and an optional `requestReference` records the originating request (e.g. a support ticket). When the account has an email on file, the user is notified by email that their account was closed. Returns 404 if no user matches the id, and 409 if the account is already deleted.
 */
export const deleteAdminUsersId = <ThrowOnError extends boolean = true>(options: Options<DeleteAdminUsersIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteAdminUsersIdResponses, DeleteAdminUsersIdErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users :id Impersonate
 *
 * Start impersonating the user identified by the `id` path parameter and return a short-lived bearer token that acts as that user against authenticated endpoints, their basic profile, and a `handoffUrl` to open the user front-office already acting as them. Requires an authenticated admin with the `users.impersonate` ability. The session expires automatically after a short window; returns 404 if no user matches the id.
 */
export const postAdminUsersIdImpersonate = <ThrowOnError extends boolean = true>(options: Options<PostAdminUsersIdImpersonateData, ThrowOnError>) => (options.client ?? client).post<PostAdminUsersIdImpersonateResponses, PostAdminUsersIdImpersonateErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}/impersonate',
    ...options
});

/**
 * Users Search
 *
 * Search users for administration, one page at a time. Requires an authenticated admin with the `users.manage` ability. Narrow results with `filters` (an explicit `ids` list for a known set or a single user, free-text `search` over name and email, `banned` state, `emailVerified` state, `mfaEnabled` state, and a `createdAt` creation-date range with inclusive `from`/`to` bounds, each usable alone) and order them with `sort`. Read `meta` for the total count and total page count, and request successive `page` values to page through the result.
 */
export const postAdminUsersSearch = <ThrowOnError extends boolean = true>(options: Options<PostAdminUsersSearchData, ThrowOnError>) => (options.client ?? client).post<PostAdminUsersSearchResponses, PostAdminUsersSearchErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users Export
 *
 * Export users using the same filters and sort supported by the user search. Small exports can be downloaded synchronously; large exports are queued.
 */
export const postAdminUsersExport = <ThrowOnError extends boolean = true>(options: Options<PostAdminUsersExportData, ThrowOnError>) => (options.client ?? client).post<PostAdminUsersExportResponses, PostAdminUsersExportErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Users :id Activity
 *
 * List the recent actions performed by the user identified by the `id` path parameter, newest-first, one page at a time. Each entry records what the user did (login, password change, MFA change, email verification, profile edit), when, and the client IP/user-agent where available. Pass the `type` query parameter to keep only one kind of action. Use `cursor` from the previous response to page; `meta.total` is the count for the current filter. Requires an authenticated admin with the `users.manage` ability.
 */
export const getAdminUsersIdActivity = <ThrowOnError extends boolean = true>(options: Options<GetAdminUsersIdActivityData, ThrowOnError>) => (options.client ?? client).get<GetAdminUsersIdActivityResponses, GetAdminUsersIdActivityErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}/activity',
    ...options
});

/**
 * Users :id Security Summary
 *
 * Return a security summary for the user identified by the `id` path parameter: whether two-factor authentication is effectively active plus counts of authenticator devices, passkeys, remaining recovery codes, and linked social accounts. Counts only. Requires an authenticated admin with the `users.manage` ability.
 */
export const getAdminUsersIdSecuritySummary = <ThrowOnError extends boolean = true>(options: Options<GetAdminUsersIdSecuritySummaryData, ThrowOnError>) => (options.client ?? client).get<GetAdminUsersIdSecuritySummaryResponses, GetAdminUsersIdSecuritySummaryErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}/security-summary',
    ...options
});

/**
 * Users :id Sessions
 *
 * List the sessions of the user identified by the `id` path parameter, newest-first, one page at a time. Includes active, expired, and revoked sessions, each with its device, IP, approximate location, creation source, and lifecycle `status`. Pass the `status` query parameter (comma-separated) to keep only sessions in given lifecycle states. Read `meta` for the total count and page count. Requires an authenticated admin with the `users.manage` ability.
 */
export const getAdminUsersIdSessions = <ThrowOnError extends boolean = true>(options: Options<GetAdminUsersIdSessionsData, ThrowOnError>) => (options.client ?? client).get<GetAdminUsersIdSessionsResponses, GetAdminUsersIdSessionsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/admin/users/{id}/sessions',
    ...options
});

/**
 * Get Status
 *
 * Return the current app configuration and a computed `status` telling the client whether it can proceed (`ok`), must update (`force_update`), or the app is under maintenance (`maintenance`). Public — no authentication required. Send the client platform and version headers so the version check applies; when omitted the check is skipped and only maintenance mode affects the status. `maintenance` details are present only while maintenance mode is active. Poll this to detect required updates or downtime.
 */
export const postAppConfigGetStatus = <ThrowOnError extends boolean = true>(options?: Options<PostAppConfigGetStatusData, ThrowOnError>) => (options?.client ?? client).post<PostAppConfigGetStatusResponses, PostAppConfigGetStatusErrors, ThrowOnError>({ url: '/app-config/get-status', ...options });

/**
 * Api Keys
 *
 * List the authenticated developer account's API keys, newest first. Plaintext secrets and secret hashes are never returned. The list includes active, expired, and revoked keys so the dashboard can show their complete lifecycle.
 */
export const getApiKeys = <ThrowOnError extends boolean = true>(options?: Options<GetApiKeysData, ThrowOnError>) => (options?.client ?? client).get<GetApiKeysResponses, GetApiKeysErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/api-keys',
    ...options
});

/**
 * Api Keys
 *
 * Create an API key owned by the authenticated developer account. Accounts can own multiple keys so each integration can use a separate credential. The plaintext key is returned exactly once in `data.key`; save it before closing this response because it cannot be retrieved later. Anonymous accounts cannot create API keys.
 */
export const postApiKeys = <ThrowOnError extends boolean = true>(options: Options<PostApiKeysData, ThrowOnError>) => (options.client ?? client).post<PostApiKeysResponses, PostApiKeysErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke All
 *
 * Revoke every active API key owned by the authenticated developer account in one operation. Revocation is permanent and the operation is idempotent; other accounts' keys are never affected.
 */
export const postApiKeysRevokeAll = <ThrowOnError extends boolean = true>(options?: Options<PostApiKeysRevokeAllData, ThrowOnError>) => (options?.client ?? client).post<PostApiKeysRevokeAllResponses, PostApiKeysRevokeAllErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/api-keys/revoke-all',
    ...options
});

/**
 * :id Revoke
 *
 * Revoke one of the authenticated developer account's API keys immediately. Revocation is permanent: create a replacement key before revoking a key that is still in use. The operation is idempotent and returns success for unknown, foreign, or already revoked identifiers.
 */
export const postApiKeysIdRevoke = <ThrowOnError extends boolean = true>(options: Options<PostApiKeysIdRevokeData, ThrowOnError>) => (options.client ?? client).post<PostApiKeysIdRevokeResponses, PostApiKeysIdRevokeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/api-keys/{id}/revoke',
    ...options
});

/**
 * Create Assets
 *
 * Register a new asset for the file described in `data` and return where to upload it. Authenticated users only; the authenticated user becomes the owner. The response carries an `upload` instruction describing exactly how to send the file bytes. Accepts the `user_photo` and `user_cover` scopes. Rejected when `mimeType` is not allowed for the `scope` or `sizeInBytes` exceeds its limit. The asset stays pending until you attach it to a resource, so upload the file and reference the returned `id` promptly — unused assets are eventually discarded.
 */
export const postAssetsCreateAssets = <ThrowOnError extends boolean = true>(options: Options<PostAssetsCreateAssetsData, ThrowOnError>) => (options.client ?? client).post<PostAssetsCreateAssetsResponses, PostAssetsCreateAssetsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/assets/create-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Up With Email
 *
 * Registers a new account with `email` and `password`. An optional `username` can be provided and a clash returns `username_taken` (409); when omitted, a unique handle is derived from the email local-part. Public; no authentication required. An unverified email — whether brand new or already on file but never confirmed — always runs the new-account flow: a one-time code is emailed, the response is `status: requires_otp` with an `emailOtpToken`, and you finish by submitting that code to `sign-in-with-email-otp`, which confirms the address, sets the chosen `password`, and signs the user in — so the password only goes live once the mailbox is proven. When the email already belongs to a verified account, the outcome depends on server configuration: it is either refused with the same generic error as an invalid sign-in (so the endpoint never reveals which verified emails are registered), or — where existing accounts are accepted — it behaves exactly like `sign-in-with-email` for that address: the correct password returns `status: success` and carries the new session (token, `csrfToken`, expiry, and the signed-in user) with browsers also receiving a session cookie; if that account has multi-factor authentication enabled the correct password is only the first factor and the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` to complete (e.g. via `verify-totp`) before any session is issued; a wrong password, or a verified account with no password set, returns the same generic error. Set `rememberMe` to keep the eventual session alive longer. Returns 429 with `retryAfterSeconds` when another sign-in code was issued for this address less than a minute ago on any branch that emails a code.
 */
export const postAuthSignUpWithEmail = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignUpWithEmailData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignUpWithEmailResponses, PostAuthSignUpWithEmailErrors, ThrowOnError>({
    url: '/auth/sign-up-with-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Signup Otp
 *
 * Emails a fresh activation code for a sign-up still awaiting confirmation, and returns a new `emailOtpToken` to pair with it. Public; no authentication required — instead pass the `emailOtpToken` you received from `sign-up-with-email`, which identifies the sign-up being resumed. Use this, and not `send-sign-in-otp`, to resend a sign-up code: only this endpoint keeps the password chosen at sign-up attached to the new code, so the account is created exactly as the user asked. The previous code stops working immediately, and the `emailOtpToken` returned here replaces the one you sent — the old pair can no longer be redeemed. Returns 401 when `emailOtpToken` is missing, expired, or was issued for a different flow. Returns 400 when it no longer identifies a sign-up awaiting confirmation — because the code was already used, the address is already confirmed, a newer code superseded it, or it belongs to a passwordless sign-in rather than a sign-up; in that case start over at `sign-up-with-email`. Returns 429 with `retryAfterSeconds` when a code was issued for this address less than a minute ago, and nothing is sent or invalidated.
 */
export const postAuthResendSignupOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthResendSignupOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthResendSignupOtpResponses, PostAuthResendSignupOtpErrors, ThrowOnError>({
    url: '/auth/resend-signup-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email
 *
 * Signs an existing user in with `email` and `password`. Public; no authentication required. This endpoint never creates an account and only accepts accounts whose email is already verified. When the password is correct the response is `status: success` and carries the new session (token, `csrfToken`, expiry, and the signed-in user); browsers also receive the session as a cookie. If the account has multi-factor authentication enabled, a correct password is only the first factor: the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use — complete one of them (e.g. `verify-totp`) to obtain the session; web clients also receive the challenge as a cookie and no session is issued yet. Set `rememberMe` to keep the eventual session alive longer. To avoid leaking which addresses are registered, an unknown email, a wrong password, a verified account that has no password set, and an account whose email is not yet verified all return the same error. An account with an unverified email must complete onboarding through `sign-up-with-email` (which parks the chosen password on the verification code and binds it once the code is redeemed); a verified passwordless account signs in through `sign-in-with-email-otp` or `sign-in-with-magic-link` instead.
 */
export const postAuthSignInWithEmail = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithEmailData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithEmailResponses, PostAuthSignInWithEmailErrors, ThrowOnError>({
    url: '/auth/sign-in-with-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Google Sign In Redirect
 *
 * Begins a Google sign-in/sign-up — or, with `intent: link`, a flow that attaches a Google identity to your account — via browser redirect, and returns the provider `url` to send the user to. Pass the relative `callback`/`errorCallback` paths on your frontend to return to when the flow finishes; optionally pass `rememberMe` and `language`. Redirect the user to `url`; the provider returns them to the callback endpoint, which sends them to `callback` (or `errorCallback` with an `error` query parameter on failure). With `intent` omitted or `sign-in` the call is public and the callback establishes a session: a first-time Google sign-in creates the account automatically. With `intent: link` you must be authenticated: the call also refuses fast with `user_already_has_provider_linked` (without sending you to the provider) when your account already has an active Google link, and otherwise the callback attaches the Google identity to your current account and returns you without issuing a new session; linking succeeds only when the Google identity is not already attached to any account.
 */
export const postAuthStartGoogleSignInRedirect = <ThrowOnError extends boolean = true>(options: Options<PostAuthStartGoogleSignInRedirectData, ThrowOnError>) => (options.client ?? client).post<PostAuthStartGoogleSignInRedirectResponses, PostAuthStartGoogleSignInRedirectErrors, ThrowOnError>({
    url: '/auth/start-google-sign-in-redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Apple Sign In Redirect
 *
 * Begins an Apple sign-in/sign-up — or, with `intent: link`, a flow that attaches an Apple identity to your account — via browser redirect, and returns the provider `url` to send the user to. Pass the relative `callback`/`errorCallback` paths on your frontend to return to when the flow finishes; optionally pass `rememberMe` and `language`. Redirect the user to `url`; the provider returns them to the callback endpoint, which sends them to `callback` (or `errorCallback` with an `error` query parameter on failure). The scope `name email` is requested — Apple posts the callback back to the backend (form_post) before the browser is returned to your `callback` path, and Apple delivers the user's `name` only on the very first sign-in (it is persisted then; subsequent sign-ins do not receive it). An Apple sign-in may create an account that has no email address when the user opts to hide it. With `intent` omitted or `sign-in` the call is public and the callback establishes a session: a first-time Apple sign-in creates the account automatically. With `intent: link` you must be authenticated: the call also refuses fast with `user_already_has_provider_linked` (without sending you to the provider) when your account already has an active Apple link, and otherwise the callback attaches the Apple identity to your current account and returns you without issuing a new session; linking succeeds only when the Apple identity is not already attached to any account. Pass `mobileBridge.deepLinkPath` to activate the mobile bridge: the backend mints a one-time token after Apple completes and redirects the user to `deepLinkPath` with `ott=<token>&state=<state>` appended; the native app then submits both to `sign-in-with-apple-mobile-ott` to obtain a bearer session.
 */
export const postAuthStartAppleSignInRedirect = <ThrowOnError extends boolean = true>(options: Options<PostAuthStartAppleSignInRedirectData, ThrowOnError>) => (options.client ?? client).post<PostAuthStartAppleSignInRedirectResponses, PostAuthStartAppleSignInRedirectErrors, ThrowOnError>({
    url: '/auth/start-apple-sign-in-redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Social Providers
 *
 * Returns the social-login providers that are ready to use, each with the public client configuration the frontend needs to start that provider's sign-in: the provider identifier, its public OAuth client ID, and the requested scopes. Public; no authentication required. A provider is included only when it is fully set up on the server — providers missing their configuration are omitted, so the returned list reflects exactly which sign-in options to show.
 */
export const postAuthGetSocialProviders = <ThrowOnError extends boolean = true>(options?: Options<PostAuthGetSocialProvidersData, ThrowOnError>) => (options?.client ?? client).post<PostAuthGetSocialProvidersResponses, PostAuthGetSocialProvidersErrors, ThrowOnError>({ url: '/auth/get-social-providers', ...options });

/**
 * Sign Out
 *
 * Ends a session and clears the session cookie. Public and idempotent: pass the session's `token` in the body, or rely on the session cookie together with a valid `x-csrf-token` header. Signing out a guest account permanently deletes it (irreversible); a full account simply has its session ended. When no recognised credentials are present it is a no-op. Always succeeds.
 */
export const postAuthSignOut = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignOutData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignOutResponses, PostAuthSignOutErrors, ThrowOnError>({
    url: '/auth/sign-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh
 *
 * Renews the session behind the access token in `token`, returning a fresh `token`, `csrfToken`, and `expiresAt` to keep the user signed in without re-authenticating. Public; the token to renew is read only from the body, never from the session cookie. Only remember-me sessions can be refreshed — short-lived sessions must be re-authenticated when they expire. A revoked, expired, or non-remember-me session, and a banned or deleted owner, are all rejected with the same generic error. Intended for mobile and API clients that hold the token directly — browser clients should instead call `get-session` to recover state after a reload. The `csrfToken` is stable across renewals.
 */
export const postAuthRefresh = <ThrowOnError extends boolean = true>(options: Options<PostAuthRefreshData, ThrowOnError>) => (options.client ?? client).post<PostAuthRefreshResponses, PostAuthRefreshErrors, ThrowOnError>({
    url: '/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session
 *
 * Returns the caller's current auth context: `sessionType` is `anonymous` when no valid session is present and `authenticated` otherwise, with the `session` and `user` blocks populated. Public; works with or without credentials, which makes it the endpoint to call on app start or after a page reload to recover the signed-in state. When authenticated it also returns a fresh `csrfToken` to attach to later mutating requests. After a social sign-in that requires a second factor, when there is no session yet but a live MFA challenge is in progress, `sessionType` is `mfa_pending` and the `mfa` block carries the challenge token, its expiry, and the methods you may use to complete it.
 */
export const postAuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<PostAuthGetSessionData, ThrowOnError>) => (options?.client ?? client).post<PostAuthGetSessionResponses, PostAuthGetSessionErrors, ThrowOnError>({ url: '/auth/get-session', ...options });

/**
 * Request Password Reset
 *
 * Starts a password reset for the account at `email`, delivered as a magic link (`type` `magic-link`) or as a one-time code (`type` `otp`). Public; no authentication required. The response is uniform whether or not the address is registered, so callers never learn which emails belong to a user. When the address does belong to an account, both the magic link and the OTP code are valid for 5 minutes and single-use. Requesting another OTP for the same address invalidates any earlier OTP still outstanding, so only the most recent code works; magic-link tokens are not superseded — every link issued for the same address stays independently valid until its 5-minute expiry. Pass `language` to localize this email (`en`/`it`); it overrides the account's stored language for this message only and is not saved. On the `otp` branch the response additionally carries an `emailOtpToken` — the signed companion the caller must echo back when submitting the code at `reset-password`; the field is always returned on this branch so the response shape stays identical across registered and unregistered emails. The `magic-link` branch does not return `emailOtpToken` because the link's token is the sole proof. Complete the reset by calling `reset-password` with the token from the magic link or the code + `emailOtpToken` from this response. Returns 429 with `retryAfterSeconds` when another reset code or link was issued for this address less than a minute ago.
 */
export const postAuthRequestPasswordReset = <ThrowOnError extends boolean = true>(options: Options<PostAuthRequestPasswordResetData, ThrowOnError>) => (options.client ?? client).post<PostAuthRequestPasswordResetResponses, PostAuthRequestPasswordResetErrors, ThrowOnError>({
    url: '/auth/request-password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 *
 * Completes a password reset by setting `newPassword` using the single-use proof obtained via `request-password-reset` (either a magic-link `token` or an emailed `otp` code, chosen by `type`). Public; no authentication required — the proof itself authorizes the call. The `otp` branch additionally requires `emailOtpToken` — the signed companion returned by `request-password-reset` on the `otp` branch — without it the code cannot be redeemed; a missing, expired, or mismatched `emailOtpToken` is rejected without burning the code, so a legitimate retry with the right token still succeeds. After five wrong attempts against the same `otp` code, the code is revoked and you must request a new one — further submissions are rejected as invalid even if you later supply the correct value. The `magic-link` branch never takes `emailOtpToken` because the link's token is the sole proof. The proof is single-use and cannot be replayed across methods — an OTP code is not accepted as a magic-link token, and vice-versa. By default every other active session on the account is revoked; set `revokeOtherSessions` to false to keep them. On `status: success` the user is signed straight in: the response carries a fresh session token (browsers also receive it as a cookie) so the client never needs a follow-up sign-in call. Set `rememberMe` to keep that session alive for an extended period instead of expiring after a day — only a remembered session can later be renewed via `refresh`. When the account has multi-factor authentication enabled, the password is still rotated and the other sessions are still invalidated, but the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use — no session is issued (and no session cookie set) until you clear one of them (e.g. `verify-totp`); the caller is therefore signed out everywhere until the second factor passes. An emailed code is never offered as a second factor here, because the reset itself was delivered by email.
 */
export const postAuthResetPassword = <ThrowOnError extends boolean = true>(options: Options<PostAuthResetPasswordData, ThrowOnError>) => (options.client ?? client).post<PostAuthResetPasswordResponses, PostAuthResetPasswordErrors, ThrowOnError>({
    url: '/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Rotates the authenticated user's password to `newPassword` after authorizing the change with one of three methods, discriminated by `type`. Authenticated, non-anonymous users only. The required method depends on the account's state and the server enforces a fixed priority: when two-factor is enabled the only accepted method is `type: "totp"` with a `deviceId` and authenticator `code`; otherwise, when the account has a password set, the method is `type: "current-password"` and the existing password must be re-confirmed; otherwise (passwordless account with a verified email) the method is `type: "otp"` and the caller must first request a code via `send-change-password-otp` and submit it here as `code` together with the `emailOtpToken` returned by that call — without it the code is rejected with `email_otp_token_invalid` and is not burned, so a legitimate retry with the right token still succeeds. After five wrong attempts against the same code the code is revoked and the caller must request a fresh one. A `type` that does not match the caller's current authorization channel is rejected. By default every other active session on the account is ended once the change succeeds; pass `revokeOtherSessions: false` to keep them. The current session is preserved either way, so no new token is issued. A passwordless account with no verified email and no two-factor enrollment cannot change its password from here and is rejected with `no_change_password_method_available`. Guest (anonymous) accounts are rejected.
 */
export const postAuthChangePassword = <ThrowOnError extends boolean = true>(options: Options<PostAuthChangePasswordData, ThrowOnError>) => (options.client ?? client).post<PostAuthChangePasswordResponses, PostAuthChangePasswordErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Change Password Otp
 *
 * Emails a single-use, time-limited code to the authenticated user's verified email address that authorizes a password change from inside an active session. Authenticated users only; the code is delivered to whatever address the account currently has on file, so no recipient is taken from the request. The code is 8 characters long, valid for 5 minutes, single-use, and bound to the calling account. The response also carries the signed `emailOtpToken` companion the caller must echo back at `change-password` with type `"otp"` together with the typed code — without it the code is not redeemable. Requesting a new code invalidates any earlier code still outstanding for the same account (and the matching `emailOtpToken` must come from the same call, since the old token cannot be paired with the new code). Returns `change_password_otp_unavailable` (400) when the account has no verified email to deliver to — typically a guest or social-only account that has never confirmed an address; in that case rely on the password-confirmation branch of `change-password` instead. Returns 429 with `retryAfterSeconds` when another code was issued for this address less than a minute ago.
 */
export const postAuthSendChangePasswordOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendChangePasswordOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendChangePasswordOtpResponses, PostAuthSendChangePasswordOtpErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/send-change-password-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Totp Authenticator
 *
 * Register a new TOTP authenticator for the authenticated user and return the setup URI plus a manual-entry secret. Authenticated users only; the account must hold a permanent identity (an email on file or at least one linked social account) — pure guest accounts are rejected so a second factor cannot lock them out forever. Render `totpURI` as a QR code, or let the user type `secret` by hand, then confirm the first generated code via `verify-totp-enrollment` to finish enrolling. There is a cap on devices per user; enrolling beyond it returns 409.
 */
export const postAuthRegisterTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<PostAuthRegisterTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<PostAuthRegisterTotpAuthenticatorResponses, PostAuthRegisterTotpAuthenticatorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/register-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Totp Authenticators
 *
 * List the authenticated user's own confirmed TOTP authenticators, one page at a time and ordered by most recent use, each with its friendly `name`, `verifiedAt`, and `lastUsedAt`. Authenticated users only; never exposes another user's devices, in-flight (unconfirmed) enrollments, or removed devices. Drives the rename (`update-totp-authenticator`) and removal (`delete-totp-authenticator`) actions. New devices appear here only after they have been confirmed via `verify-totp-enrollment`.
 */
export const postAuthListTotpAuthenticators = <ThrowOnError extends boolean = true>(options: Options<PostAuthListTotpAuthenticatorsData, ThrowOnError>) => (options.client ?? client).post<PostAuthListTotpAuthenticatorsResponses, PostAuthListTotpAuthenticatorsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/list-totp-authenticators',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Totp Authenticator
 *
 * Rename one of the authenticated user's own confirmed TOTP authenticators. Authenticated users only; you can only update an authenticator you own that has already been confirmed via `verify-totp-enrollment`. Pass the device `id` and the new `name` — the response echoes the device in its updated form. Use this to label multiple authenticators (e.g. 'Pixel 8', 'Work laptop'). Removing an authenticator is done via `delete-totp-authenticator`.
 */
export const postAuthUpdateTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<PostAuthUpdateTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<PostAuthUpdateTotpAuthenticatorResponses, PostAuthUpdateTotpAuthenticatorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/update-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Totp Authenticator
 *
 * Remove one of the authenticated user's own TOTP authenticators, identified by `id`. Authenticated users only. Idempotent and always succeeds: removing a device that does not exist, is not yours, or is already removed returns success with no effect, so callers cannot probe which device ids exist. Once removed the device can no longer be used to verify a code; you can re-enroll it later via `register-totp-authenticator`. Removing the last verified device does not automatically turn off two-factor for the account — use `disable-two-factor` to do so explicitly. List the available authenticators with `list-totp-authenticators`.
 */
export const postAuthDeleteTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<PostAuthDeleteTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<PostAuthDeleteTotpAuthenticatorResponses, PostAuthDeleteTotpAuthenticatorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/delete-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable Two Factor
 *
 * Turn off two-factor authentication on the authenticated user's account so future sign-ins no longer require a second factor. Authenticated users only. Requires a second-factor step-up so a stolen session alone cannot disable MFA: pick a method via the discriminated `type` field. TOTP and passkey are the primary channels — either is accepted whenever the corresponding factor is enrolled. Recovery codes are accepted as single-use break-glass credentials from an authenticated session. Email OTP is the fallback and is only accepted when the account has neither a TOTP authenticator nor a passkey enrolled, and has a verified email on file; in that case obtain the code first via `send-disable-two-factor-otp`. A `type` that does not match the account's enrolled factors is rejected with `disable_two_factor_method_not_available`. An account with none of (TOTP, passkey, verified email) needs no step-up — submit any supported `type` carrying a placeholder credential and the call still succeeds, since no second factor exists to challenge. Idempotent: calling on an already-disabled account still succeeds with no effect. Registered TOTP authenticators and unused recovery codes are preserved, so the user can re-enable later via `enable-two-factor` without re-enrolling.
 */
export const postAuthDisableTwoFactor = <ThrowOnError extends boolean = true>(options: Options<PostAuthDisableTwoFactorData, ThrowOnError>) => (options.client ?? client).post<PostAuthDisableTwoFactorResponses, PostAuthDisableTwoFactorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/disable-two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Disable Two Factor Otp
 *
 * Emails a single-use, time-limited code to the authenticated user's verified email address that authorizes disabling two-factor authentication from inside an active session. Authenticated users only; the code is delivered to whatever address the account currently has on file, so no recipient is taken from the request. The code is 8 characters long, valid for 5 minutes, single-use, and bound to the calling account — pair it with `disable-two-factor` by submitting `type: "email-otp"` and the received code to complete the operation. The email-OTP channel is the fallback second factor reserved for accounts that have neither a TOTP authenticator nor a passkey enrolled; if you have either, this endpoint returns `disable_two_factor_otp_unavailable` (400) and you must clear the step-up via `disable-two-factor` with `type: "totp"` or `type: "passkey"` instead. The same error is returned when the account has no verified email to deliver the code to. Requesting a new code invalidates any earlier code still outstanding for the same account, so only the most recently sent code works. Returns 429 with `retryAfterSeconds` when another code was issued for this address less than a minute ago.
 */
export const postAuthSendDisableTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendDisableTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendDisableTwoFactorOtpResponses, PostAuthSendDisableTwoFactorOtpErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/send-disable-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Two Factor
 *
 * Turn on two-factor authentication on the authenticated user's account. Authenticated users only; the account must hold a permanent identity (an email on file or at least one linked social account) — pure guest accounts are rejected so a second factor cannot lock them out forever. Idempotent: calling on an already-enabled account succeeds with no effect. Raising this flag alone does not force a challenge at sign-in — the user must also have at least one verified authenticator (enroll one via `register-totp-authenticator` + `verify-totp-enrollment`); without it the next sign-in proceeds without a second factor and the inconsistency is surfaced for the user to resolve.
 */
export const postAuthEnableTwoFactor = <ThrowOnError extends boolean = true>(options: Options<PostAuthEnableTwoFactorData, ThrowOnError>) => (options.client ?? client).post<PostAuthEnableTwoFactorResponses, PostAuthEnableTwoFactorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/enable-two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Totp
 *
 * Verifies an authenticator `code` for the chosen `deviceId` during a sign-in MFA challenge and, on success, issues your session. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. On a wrong code you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const postAuthVerifyTotp = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyTotpData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyTotpResponses, PostAuthVerifyTotpErrors, ThrowOnError>({
    url: '/auth/verify-totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Totp Enrollment
 *
 * Confirm a just-registered authenticator by submitting the first `code` it shows for `deviceId` from `register-totp-authenticator`. On success the device is activated and two-factor authentication is enabled on the account. Authenticated users only. Returns 400 when the code is wrong or the short enrollment window has expired — restart enrollment via `register-totp-authenticator`. The returned identity reflects the now-enabled state. The submitted `code` is single-use: only the unverified-to-verified transition consumes it, so retrying this call for an already-confirmed device with the same in-window code still resolves successfully (idempotent retry on flaky networks).
 */
export const postAuthVerifyTotpEnrollment = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyTotpEnrollmentData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyTotpEnrollmentResponses, PostAuthVerifyTotpEnrollmentErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/verify-totp-enrollment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Backup Codes
 *
 * Generate a fresh batch of single-use recovery codes (10) for the authenticated user, invalidating any previously-issued unused codes. Authenticated users only; the account must hold a permanent identity (an email on file or at least one linked social account) and MFA must already be active — enroll an authenticator via `register-totp-authenticator` + `verify-totp-enrollment` first, otherwise the call is rejected. The codes are returned in cleartext exactly once and cannot be retrieved later — present them immediately so the user can store them.
 */
export const postAuthGenerateBackupCodes = <ThrowOnError extends boolean = true>(options: Options<PostAuthGenerateBackupCodesData, ThrowOnError>) => (options.client ?? client).post<PostAuthGenerateBackupCodesResponses, PostAuthGenerateBackupCodesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/generate-backup-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Backup Code
 *
 * Verifies a one-time backup recovery `code` during a sign-in MFA challenge — the break-glass fallback when you cannot use your authenticator — and, on success, issues your session. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. A wrong code may be retried with the same challenge until it is revoked after too many failed attempts. Each valid backup code works only once.
 */
export const postAuthVerifyBackupCode = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyBackupCodeData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyBackupCodeResponses, PostAuthVerifyBackupCodeErrors, ThrowOnError>({
    url: '/auth/verify-backup-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Two Factor Otp
 *
 * Emails a one-time code as the second factor for an in-progress sign-in MFA challenge. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read — an invalid challenge is rejected. Email codes are only offered when you signed in with a password, your account has a verified email, and your account has neither a TOTP authenticator nor a passkey enrolled — email OTP is reserved as a fallback for users without a stronger factor; if you have a TOTP authenticator or a passkey you must use those instead. After it succeeds, submit the code via `verify-two-factor-otp`. The code expires after a short window, and requesting a new one invalidates any earlier code still outstanding. Returns 429 with `retryAfterSeconds` when another code was requested less than a minute ago.
 */
export const postAuthSendTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendTwoFactorOtpResponses, PostAuthSendTwoFactorOtpErrors, ThrowOnError>({
    url: '/auth/send-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Two Factor Otp
 *
 * Verifies the one-time `code` emailed during a sign-in MFA challenge and, on success, issues your session. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. Request the code first via `send-two-factor-otp`. Email codes are only accepted as a second factor when you signed in with a password and your account has neither a TOTP authenticator nor a passkey enrolled — email OTP is reserved as a fallback for users without a stronger factor; if you have a TOTP authenticator or a passkey you must use those instead. For a passwordless, social, or passkey sign-in the call is rejected. On a wrong code you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const postAuthVerifyTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyTwoFactorOtpResponses, PostAuthVerifyTwoFactorOtpErrors, ThrowOnError>({
    url: '/auth/verify-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Two Factor Passkey
 *
 * Completes a sign-in MFA challenge with a passkey assertion and, on success, issues your session. Public; no authentication required. First call `generate-passkey-step-up-options` to obtain the WebAuthn options, assert the passkey, then send the `response` here. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. Any valid passkey assertion belonging to the account that started this sign-in clears the challenge — user verification (biometric / PIN) is NOT required when a passkey is used as a second factor, only possession of a registered credential. A passkey is NOT an available second factor when the first factor was itself a passkey: pairing the two would collapse both factors to a single credential or to mere possession of a registered credential, so the call is rejected — use TOTP or a recovery code instead. An assertion that belongs to a different account is rejected. On rejection you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const postAuthVerifyTwoFactorPasskey = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyTwoFactorPasskeyData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyTwoFactorPasskeyResponses, PostAuthVerifyTwoFactorPasskeyErrors, ThrowOnError>({
    url: '/auth/verify-two-factor-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sessions
 *
 * List the authenticated user's own sessions, one page at a time and ordered by most recent activity, each with its approximate location, device details, and lifecycle `status`. Authenticated users only; never exposes another user's sessions. Revoked and expired sessions stay in the list and are surfaced through `status`, while the session the request was made with is flagged by `isCurrent`. When the caller is being impersonated by an admin, the list also includes impersonation sessions. Pass `filters.status` to keep only sessions in a given lifecycle state. End any session with `revoke-session`.
 */
export const postAuthListSessions = <ThrowOnError extends boolean = true>(options: Options<PostAuthListSessionsData, ThrowOnError>) => (options.client ?? client).post<PostAuthListSessionsResponses, PostAuthListSessionsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/list-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Session
 *
 * Revokes the session identified by `sessionId`, signing out that device. Authenticated users only. Idempotent and always succeeds: revoking a session that does not exist, is not yours, or is already revoked returns success with no effect, so callers cannot probe which sessions exist. An ordinary user can only revoke their own non-impersonation sessions; a caller who is themselves being impersonated can also revoke impersonation sessions, including the one driving the request. Revoking the session the call was made with immediately signs the caller out — subsequent requests will fail until they authenticate again. List the available sessions with `list-sessions`.
 */
export const postAuthRevokeSession = <ThrowOnError extends boolean = true>(options: Options<PostAuthRevokeSessionData, ThrowOnError>) => (options.client ?? client).post<PostAuthRevokeSessionResponses, PostAuthRevokeSessionErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/revoke-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Other Sessions
 *
 * Revokes every other active session on your account, signing out all your other devices while keeping the current one alive. Authenticated users only. Idempotent and always succeeds: when there is nothing else to revoke it still returns success. Impersonation sessions opened by an admin are preserved — only that admin can end them. Use this for a "sign out everywhere else" action; to end a single device use `revoke-session`, and to review your sessions use `list-sessions`.
 */
export const postAuthRevokeOtherSessions = <ThrowOnError extends boolean = true>(options?: Options<PostAuthRevokeOtherSessionsData, ThrowOnError>) => (options?.client ?? client).post<PostAuthRevokeOtherSessionsResponses, PostAuthRevokeOtherSessionsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/revoke-other-sessions',
    ...options
});

/**
 * Adopt Impersonation Session
 *
 * Adopts an admin-issued impersonation session into the front-office session cookie, so the browser then acts as the impersonated user. Public; the token is read only from the body. Accepts only a live impersonation session — a normal user session, and an invalid, expired, or revoked token, are all rejected with the same generic error. On success the session cookie is set with the impersonation session's own short expiry; call `get-session` next to recover the `csrfToken`. End it with `sign-out` or let it expire.
 */
export const postAuthAdoptImpersonationSession = <ThrowOnError extends boolean = true>(options: Options<PostAuthAdoptImpersonationSessionData, ThrowOnError>) => (options.client ?? client).post<PostAuthAdoptImpersonationSessionResponses, PostAuthAdoptImpersonationSessionErrors, ThrowOnError>({
    url: '/auth/adopt-impersonation-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Google
 *
 * Completes a Google sign-in/sign-up, or links a Google identity to your account, depending on `intent`. Public; no authentication required for sign-in. Pass either a native `token` (an id_token that carries the `nonce` from a prior `issue-social-native-nonce` call) when `type` is `token`, or an authorization `code` from the web Google Identity Services popup when `type` is `code`; the backend completes the popup exchange against the fixed redirect. When `type` is `code`, you must also pass the PKCE `codeVerifier` matching the `code_challenge` your client sent to Google Identity Services at popup init; this binds the authorization code to the client that started the popup, so a lifted code is not replayable. When `type` is `token`, the supplied id_token must have been issued by Google within the last 5 minutes; older id_tokens are rejected even when still valid at the provider, so request a fresh nonce and a fresh id_token per attempt. Optionally pass `rememberMe` and `language`. With `intent` omitted or `sign-in` a first-time Google sign-in creates the account automatically; if an account already exists with Google's verified email, this login is linked to it and you are signed into that account (and the email is confirmed if it was not already); the response has `status: signed_in` carrying the session token and the `csrfToken` to attach to later mutating requests, and browsers additionally receive the session as a cookie. If the resolved account has multi-factor authentication enabled, no session is issued yet: the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use — complete one of them (e.g. `verify-totp`) to obtain the session; web clients also receive the challenge as a cookie. With `intent: link` you must be authenticated: the Google identity is attached to your current account and the response has `status: linked` carrying only your identity — no new session is issued, no cookie is set, and your email is left untouched; when the caller was a guest, the link also promotes the account to a regular one — it is no longer a guest after this call succeeds. Linking succeeds only when the caller does not already have an active Google account (otherwise `user_already_has_provider_linked`), the Google identity is not already attached to any account (otherwise `social_account_already_linked`), and Google's email is not already known to the system (otherwise `email_already_in_use`); use the normal sign-in instead, which merges that identity into the account owning the email. The provider's email need not be verified for a link.
 */
export const postAuthSignInWithGoogle = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithGoogleData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithGoogleResponses, PostAuthSignInWithGoogleErrors, ThrowOnError>({
    url: '/auth/sign-in-with-google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Apple
 *
 * Completes an Apple sign-in/sign-up, or links an Apple identity to your account, depending on `intent`. Public; no authentication required for sign-in. Pass a native iOS `token` (id_token) that carries the `nonce` from a prior `issue-social-native-nonce` call — Apple has no web `code` path here, so the browser redirect flow is the route for web sign-in. The supplied id_token must have been issued by Apple within the last 5 minutes; older id_tokens are rejected even when still valid at the provider, so request a fresh nonce and a fresh id_token per attempt. Optionally pass `rememberMe` and `language`. Apple may return no email when the user opted out of sharing it, in which case the account is created emailless on a first-time sign-in. With `intent` omitted or `sign-in` a first-time Apple sign-in creates the account automatically; if an account already exists with Apple's verified email, this login is linked to it and you are signed into that account (and the email is confirmed if it was not already); the response has `status: signed_in` carrying the session token and the `csrfToken` to attach to later mutating requests, and browsers additionally receive the session as a cookie. If the resolved account has multi-factor authentication enabled, no session is issued yet: the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use — complete one of them (e.g. `verify-totp`) to obtain the session; web clients also receive the challenge as a cookie. With `intent: link` you must be authenticated: the Apple identity is attached to your current account and the response has `status: linked` carrying only your identity — no new session is issued, no cookie is set, and your email is left untouched; when the caller was a guest, the link also promotes the account to a regular one — it is no longer a guest after this call succeeds. Linking succeeds only when the caller does not already have an active Apple account (otherwise `user_already_has_provider_linked`), the Apple identity is not already attached to any account (otherwise `social_account_already_linked`), and — when Apple returns an email — that email is not already known to the system (otherwise `email_already_in_use`); use the normal sign-in instead, which merges that identity into the account owning the email. An Apple sign-in that returns no email (the user hid it) is gated on the social and per-user-provider checks alone. The provider's email need not be verified for a link.
 */
export const postAuthSignInWithApple = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithAppleData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithAppleResponses, PostAuthSignInWithAppleErrors, ThrowOnError>({
    url: '/auth/sign-in-with-apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Issue Social Native Nonce
 *
 * Issues a single-use nonce for a native social sign-in. Public; no authentication required. Call this first, attach the returned `nonce` to the provider's on-device sign-in request (e.g. Google Sign-In), then pass the resulting native `token` to `sign-in-with-google` or `sign-in-with-apple`; the backend matches the nonce once and rejects a replayed or expired token. The nonce is consumed on use and is short-lived — request a fresh one per sign-in attempt.
 */
export const postAuthIssueSocialNativeNonce = <ThrowOnError extends boolean = true>(options?: Options<PostAuthIssueSocialNativeNonceData, ThrowOnError>) => (options?.client ?? client).post<PostAuthIssueSocialNativeNonceResponses, PostAuthIssueSocialNativeNonceErrors, ThrowOnError>({ url: '/auth/issue-social-native-nonce', ...options });

/**
 * Verify Email
 *
 * Confirms ownership of an email address by redeeming a single-use proof issued for it. Public; no authentication required, but the caller's session (when present) decides the outcome. Two interchangeable proofs are accepted via `type`: an `otp` code issued via `send-email-verification-otp`, or a `magic-link` token issued via `send-email-verification-magic-link`. The `otp` branch additionally requires `emailOtpToken` — the signed companion returned by `send-email-verification-otp` — without it the code cannot be redeemed; a missing, expired, or shape-invalid `emailOtpToken` is rejected without burning the code, so a legitimate retry with the right token still succeeds. The OTP branch carries no `email` field: the address the code was issued for is recovered from the signed `emailOtpToken`. After five wrong attempts against the same `otp` code, the code is revoked and you must request a new one — further submissions are rejected as invalid even if you later supply the correct value. On the `magic-link` branch the body's `email` must match the address the token was issued for (case-insensitive); a mismatch is rejected with the same generic error as an invalid proof, so the call can never be used to enumerate which addresses are registered. Verifying an address that is already verified succeeds with no effect (idempotent). The outcome depends on the caller's current session: when unauthenticated, the matching account is signed in and the response is `signed_in` carrying the session token, the `csrfToken` to attach to later mutating requests, the session's `expiresAt`, and the user identity — browsers additionally receive the session as a cookie; when already signed in as the same user, the response is `verified` and the current session is kept; when already signed in as a different user, the current session is ended server-side and the response is `signed_in` for the verified account (cookie reissued). When the account being signed in has multi-factor authentication enabled, the email is still confirmed (and any previous different-user session is still ended), but the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use — no session is issued (and no session cookie set) until you clear one of them (e.g. `verify-totp`). An emailed code is never offered as a second factor here, because email verification is itself an email proof. The same-user `verified` branch never challenges. The session's lifetime when one is issued reflects the `rememberMe` choice made when the proof was requested: a remembered session stays valid for an extended period, otherwise it expires after a day.
 */
export const postAuthVerifyEmail = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyEmailData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyEmailResponses, PostAuthVerifyEmailErrors, ThrowOnError>({
    url: '/auth/verify-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Sign In Magic Link
 *
 * Emails a single-use, time-limited sign-in magic link to the address in `email`. Public; no authentication required. The response is always success and never reveals whether the address is registered — a link is always sent, even to an unknown address, so completing `sign-in-with-magic-link` creates the account when the address is new (the same call serves both sign-up and sign-in). The link is valid once and expires after a short window, after which you must request a new one. Pass `language` to localize this email (`en`/`it`); it overrides the account's stored language for this message only and is not saved. Pass `rememberMe` to keep the session issued once the link is verified alive longer instead of expiring after a day. Pair with `sign-in-with-magic-link` to consume the link. Returns 429 with `retryAfterSeconds` when another link was issued for this address less than a minute ago.
 */
export const postAuthSendSignInMagicLink = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendSignInMagicLinkData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendSignInMagicLinkResponses, PostAuthSendSignInMagicLinkErrors, ThrowOnError>({
    url: '/auth/send-sign-in-magic-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Email Verification Magic Link
 *
 * Emails a single-use, time-limited magic link to the address in `email` to confirm ownership of an existing, still-unverified account. Public; no authentication required. The response is always success and never reveals whether the address belongs to a registered account — a link is only actually emailed when the address belongs to an existing, still-unverified account; otherwise nothing is sent. The link is valid once and expires after a short window, after which you must request a new one. Magic links are not superseded across resends — every link issued for the same address stays independently valid until its expiry. Pass `language` to localize this email (`en`/`it`); it overrides the account's stored language for this message only and is not saved. Pass `rememberMe` so the session issued after the address is verified stays valid for an extended period instead of expiring after a day. Pair with `verify-email` to consume the link. Returns 429 with `retryAfterSeconds` when another link was issued for this address less than a minute ago.
 */
export const postAuthSendEmailVerificationMagicLink = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendEmailVerificationMagicLinkData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendEmailVerificationMagicLinkResponses, PostAuthSendEmailVerificationMagicLinkErrors, ThrowOnError>({
    url: '/auth/send-email-verification-magic-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Magic Link
 *
 * Completes passwordless sign-in by redeeming the `token` from a magic link, returning a new session. Public; no authentication required. Pairs with `send-sign-in-magic-link`, which delivers the link. The token is single-use and expires shortly after it is sent, so a reused or stale link is rejected; a link minted for an address that no longer has an account is also rejected. A successful sign-in also confirms the address if it was not yet verified. The response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie. You may pass `language` (`en`/`it`) to store the interface language on an account that has none yet (e.g. one just created via `send-sign-in-magic-link`); it is ignored when the account already has a stored language. The returned session's lifetime reflects the `rememberMe` choice made when the link was requested: a remembered session stays valid for an extended period, otherwise it expires after a day. If the account has multi-factor authentication enabled, redeeming the link is only the first factor: the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use (an emailed code is never offered as a second factor here) — complete one of them (e.g. `verify-totp`) to obtain the session; web clients also receive the challenge as a cookie and no session is issued yet.
 */
export const postAuthSignInWithMagicLink = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithMagicLinkData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithMagicLinkResponses, PostAuthSignInWithMagicLinkErrors, ThrowOnError>({
    url: '/auth/sign-in-with-magic-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Sign In Otp
 *
 * Emails a single-use, time-limited sign-in code to the address in `email`, and returns the signed `emailOtpToken` companion the caller must echo back when submitting that code. Public; no authentication required. The response is always success and never reveals whether the address is registered — a code is always sent, even to an unknown address, so completing `sign-in-with-email-otp` creates the account when the address is new. The code is valid once and expires after a short window, after which you must request a new one. Requesting a new code for the same address invalidates any earlier code still outstanding, so only the most recently sent code works. Pass `language` to localize this email (`en`/`it`); it overrides the account's stored language for this message only and is not saved. Pass `rememberMe` to keep the session issued once the code is verified alive longer instead of expiring after a day. Returns 429 with `retryAfterSeconds` when another code was issued for this address less than a minute ago.
 */
export const postAuthSendSignInOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendSignInOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendSignInOtpResponses, PostAuthSendSignInOtpErrors, ThrowOnError>({
    url: '/auth/send-sign-in-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Email Verification Otp
 *
 * Emails a single-use, time-limited code to the address in `email` to confirm ownership of an existing, still-unverified account, and returns the signed `emailOtpToken` companion the caller must echo back when submitting that code at `verify-email`. Public; no authentication required. The response is always success and never reveals whether the address belongs to a registered account — a code is only actually emailed when the address belongs to an existing, still-unverified account; otherwise nothing is sent. The `emailOtpToken` is always returned so the response shape is identical across registered, unregistered, and already-verified addresses; a token minted for a non-eligible address is harmless because no code is paired with it. The code is valid once and expires after a short window, after which you must request a new one. Requesting a new code for the same address invalidates any earlier code still outstanding, so only the most recently sent code works — and the matching `emailOtpToken` must come from the same call, since the old token cannot be paired with the new code. Pass `language` to localize this email (`en`/`it`); it overrides the account's stored language for this message only and is not saved. Pass `rememberMe` so the session issued after the address is verified stays valid for an extended period instead of expiring after a day. Pair with `verify-email` to consume the code. Returns 429 with `retryAfterSeconds` when another code was issued for this address less than a minute ago.
 */
export const postAuthSendEmailVerificationOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthSendEmailVerificationOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthSendEmailVerificationOtpResponses, PostAuthSendEmailVerificationOtpErrors, ThrowOnError>({
    url: '/auth/send-email-verification-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email Otp
 *
 * Completes passwordless sign-in by validating the `otp` together with the `emailOtpToken` returned by the request that issued the code, returning a new session. The address the code was issued for is carried inside the signed `emailOtpToken`, so the body needs neither an `email` nor any further binding check. Public; no authentication required. If the address has no account yet, one is created on the fly and signed in — so the same call serves both sign-in and sign-up. You may pass `language` to set the new account's interface language when it is created on the fly; it is ignored when the account already exists. Pairs with `send-sign-in-otp`, which delivers the code and the `emailOtpToken` you must echo back. The code is single-use and expires shortly after it is sent, so a wrong, reused, or stale code is rejected; an `emailOtpToken` that is missing, expired, or shape-invalid is rejected separately without burning the code, so a legitimate retry with the right token still succeeds. After five wrong attempts against the same code, the code is revoked and you must request a new one — further submissions are rejected as invalid even if you later supply the correct value. A successful sign-in also confirms the address if it was not yet verified. The response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie. The session's lifetime reflects the `rememberMe` choice made when the code was requested: a remembered session stays valid for an extended period, otherwise it expires after a day. When the code was requested from `sign-up-with-email`, verifying it here also sets the password chosen there — but only if the account does not already have one. If the account has multi-factor authentication enabled, the code is only the first factor: the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use (an emailed code is never offered as a second factor here) — complete one of them (e.g. `verify-totp`) to obtain the session; web clients also receive the challenge as a cookie and no session is issued yet.
 */
export const postAuthSignInWithEmailOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithEmailOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithEmailOtpResponses, PostAuthSignInWithEmailOtpErrors, ThrowOnError>({
    url: '/auth/sign-in-with-email-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Register Options
 *
 * Returns the WebAuthn options the authenticator needs to create a new passkey for the signed-in user, together with a short-lived `passkeyToken`. Authenticated users only — this enrolls an additional passkey, it does not sign anyone in. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `verify-passkey-registration` to finish enrollment. The authenticator is told about existing passkeys for this account so it refuses to enroll one already in use. Optionally constrain the authenticator type via `authenticatorAttachment`. Rejected with 409 when the account has reached the maximum number of registered passkeys — remove an existing passkey before enrolling a new one.
 */
export const postAuthGeneratePasskeyRegisterOptions = <ThrowOnError extends boolean = true>(options: Options<PostAuthGeneratePasskeyRegisterOptionsData, ThrowOnError>) => (options.client ?? client).post<PostAuthGeneratePasskeyRegisterOptionsResponses, PostAuthGeneratePasskeyRegisterOptionsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/generate-passkey-register-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Sign In Options
 *
 * Returns the WebAuthn options the authenticator needs to assert an existing passkey, together with a short-lived `passkeyToken`. Public; no authentication required — this starts a passkey sign-in. The options do not list which credentials exist on the server, so the client surfaces the platform's native credential selector and the server resolves the user from whichever passkey the authenticator returns. User verification (biometric or PIN) is required for sign-in via passkey, so the assertion the authenticator returns must be user-verified; credentials that cannot perform UV remain usable as a second factor via `generate-passkey-step-up-options`. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `sign-in-with-passkey` to finish signing in.
 */
export const postAuthGeneratePasskeySignInOptions = <ThrowOnError extends boolean = true>(options: Options<PostAuthGeneratePasskeySignInOptionsData, ThrowOnError>) => (options.client ?? client).post<PostAuthGeneratePasskeySignInOptionsResponses, PostAuthGeneratePasskeySignInOptionsErrors, ThrowOnError>({
    url: '/auth/generate-passkey-sign-in-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Sign Up Options
 *
 * Returns the WebAuthn options the authenticator needs to create a brand-new passkey for a brand-new account, together with a short-lived `passkeyToken`. Public; no authentication required — this starts a passkey-only sign-up that mints a fresh user record on success (no email, no name collected upfront). The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `sign-up-with-passkey` to finalize account creation. User verification (biometric or PIN) AND a discoverable resident key are both required, so the resulting credential can later sign in on its own via `generate-passkey-sign-in-options` — authenticators that cannot perform UV or cannot create a discoverable credential (e.g. a security key without a PIN) will fail this ceremony. The account name and display name shown by the authenticator's save-credential prompt are generic placeholders, since no user profile exists yet.
 */
export const postAuthGeneratePasskeySignUpOptions = <ThrowOnError extends boolean = true>(options: Options<PostAuthGeneratePasskeySignUpOptionsData, ThrowOnError>) => (options.client ?? client).post<PostAuthGeneratePasskeySignUpOptionsResponses, PostAuthGeneratePasskeySignUpOptionsErrors, ThrowOnError>({
    url: '/auth/generate-passkey-sign-up-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Step Up Options
 *
 * Returns the WebAuthn options the authenticator needs to assert an existing passkey as a second factor, together with a short-lived `passkeyToken`. Public; no authentication required — this is called between a `requires_mfa` response and `verify-two-factor-passkey`. User verification is `preferred` (not `required`) on purpose: as an explicit second factor a passkey only needs to prove possession of a registered credential of the account, so a non-UV authenticator (e.g. a security key without a PIN) is still accepted — matching the semantics of `verify-two-factor-passkey`. The options do not list which credentials exist on the server, so the client surfaces the platform's native credential selector. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `verify-two-factor-passkey` to clear the MFA challenge.
 */
export const postAuthGeneratePasskeyStepUpOptions = <ThrowOnError extends boolean = true>(options: Options<PostAuthGeneratePasskeyStepUpOptionsData, ThrowOnError>) => (options.client ?? client).post<PostAuthGeneratePasskeyStepUpOptionsResponses, PostAuthGeneratePasskeyStepUpOptionsErrors, ThrowOnError>({
    url: '/auth/generate-passkey-step-up-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Passkey Registration
 *
 * Verifies the authenticator's response and registers the passkey on the signed-in user's account. Authenticated users only — this completes enrollment, it does not sign anyone in. Send the `response` produced by the authenticator together with the `passkeyToken` from `generate-passkey-register-options`; on success the new passkey becomes usable for passkey sign-in. Rejected with 409 when the account has reached the maximum number of registered passkeys — remove an existing passkey before enrolling a new one.
 */
export const postAuthVerifyPasskeyRegistration = <ThrowOnError extends boolean = true>(options: Options<PostAuthVerifyPasskeyRegistrationData, ThrowOnError>) => (options.client ?? client).post<PostAuthVerifyPasskeyRegistrationResponses, PostAuthVerifyPasskeyRegistrationErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/verify-passkey-registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Passkey
 *
 * Completes a passkey sign-in by verifying the authenticator's assertion against a previously registered passkey. Public; no authentication required. Pairs with `generate-passkey-sign-in-options`, which mints the WebAuthn challenge and the matching `passkeyToken`. The token is single-use and expires shortly after it is issued, so a reused or stale challenge is rejected. The assertion must be user-verified — the authenticator collected a biometric or PIN — so a passkey signed in here satisfies multi-factor authentication on its own and the session is issued immediately, even when the account has MFA enabled. An assertion that only proved user presence (no verification, e.g. a security key without a PIN) is rejected; those credentials are still usable as a second factor via `verify-two-factor-passkey`. An unknown credential, a bad signature, and a counter rollback (cloned-key detection) all collapse to the same error so the endpoint cannot be used to probe which passkeys exist on the server. Set `rememberMe` to keep the session alive for an extended period instead of expiring after a day. On success the response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie.
 */
export const postAuthSignInWithPasskey = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithPasskeyData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithPasskeyResponses, PostAuthSignInWithPasskeyErrors, ThrowOnError>({
    url: '/auth/sign-in-with-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Up With Passkey
 *
 * Completes a passkey sign-up by verifying the authenticator's attestation against a previously issued sign-up challenge, then issuing a fresh session. Public; no authentication required, and no email or name is collected here — the new account starts credentialless apart from the passkey and can fill in profile data later through account-settings endpoints. A passkey does not by itself identify the account as a non-guest: every account this endpoint creates is an anonymous (guest) account whose `isAnonymous` is `true`, and the flag only flips to `false` once the account also binds an email or links a social provider. The assertion must be user-verified (biometric or PIN) and produce a discoverable resident credential, matching the constraints `generate-passkey-sign-up-options` set; a presence-only response (e.g. a security key without a PIN) is rejected. The endpoint branches on the current credential: with no session a brand-new anonymous account is created and signed in; while signed in as a guest the same user id is kept and the new passkey is attached to it without ever flipping `isAnonymous`, then the previous guest session is revoked so only the freshly issued passkey session survives; while signed in as a full (non-guest) account the call is treated as a fresh sign-up — the previous session is revoked, a brand-new anonymous account is created, and the passkey is attached to that new account, so the caller ends up signed in on a different account than they were (use `register-passkey` from the existing session to add a passkey to the current account instead). An unknown or already-consumed `passkeyToken` is rejected with the same generic error as a malformed attestation, so the endpoint cannot be used to probe which challenges are live. On success the response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie.
 */
export const postAuthSignUpWithPasskey = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignUpWithPasskeyData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignUpWithPasskeyResponses, PostAuthSignUpWithPasskeyErrors, ThrowOnError>({
    url: '/auth/sign-up-with-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Passkeys
 *
 * List the authenticated user's own passkeys, one page at a time and ordered by most recent use, each with its friendly `name`, device details, and `lastUsedAt`. Authenticated users only; never exposes another user's passkeys. Drives the rename (`update-passkey`) and removal (`delete-passkey`) actions.
 */
export const postAuthListPasskeys = <ThrowOnError extends boolean = true>(options: Options<PostAuthListPasskeysData, ThrowOnError>) => (options.client ?? client).post<PostAuthListPasskeysResponses, PostAuthListPasskeysErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/list-passkeys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Passkey
 *
 * Remove one of the authenticated user's own passkeys, identified by `id`. Authenticated users only. Idempotent and always succeeds: removing a passkey that does not exist, is not yours, or is already removed returns success with no effect, so callers cannot probe which passkey ids exist. Once removed the passkey can no longer be used to sign in; you can re-enroll the same authenticator later. List the available passkeys with `list-passkeys`.
 */
export const postAuthDeletePasskey = <ThrowOnError extends boolean = true>(options: Options<PostAuthDeletePasskeyData, ThrowOnError>) => (options.client ?? client).post<PostAuthDeletePasskeyResponses, PostAuthDeletePasskeyErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/delete-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Passkey
 *
 * Rename one of the authenticated user's own passkeys. Authenticated users only; you can only update a passkey you own. Pass the passkey `id` and the new `name` — the response echoes the passkey in its updated form. Use this to label multiple passkeys (e.g. 'MacBook Touch ID', 'YubiKey'). Removing a passkey is done via `delete-passkey`.
 */
export const postAuthUpdatePasskey = <ThrowOnError extends boolean = true>(options: Options<PostAuthUpdatePasskeyData, ThrowOnError>) => (options.client ?? client).post<PostAuthUpdatePasskeyResponses, PostAuthUpdatePasskeyErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/update-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Email Change
 *
 * Start changing the authenticated user's email to `newEmail` by sending a one-time code to that new address. If the account already has an email, a second code is also sent to the current address and both are required to confirm. Authenticated users only. The codes are single-use and expire shortly after they are sent; submit them with `newEmail` and the `emailOtpToken` returned here to `confirm-email-change` to apply the change. The response field `currentEmailVerificationRequired` is true when a code was also sent to the current address. The single `emailOtpToken` covers both codes when two were issued, and submitting the codes without it (or with a stale one from a previous call) is rejected at confirm time without consuming either code. The response is uniform whether or not `newEmail` already belongs to another account, so callers cannot learn which addresses are registered; an ownership clash is only surfaced at `confirm-email-change` once the caller has proven possession of the new mailbox. Returns 400 only when `newEmail` matches the current address. Returns 429 with `retryAfterSeconds` when a code was issued less than a minute ago for either the current or the new address.
 */
export const postAuthRequestEmailChange = <ThrowOnError extends boolean = true>(options: Options<PostAuthRequestEmailChangeData, ThrowOnError>) => (options.client ?? client).post<PostAuthRequestEmailChangeResponses, PostAuthRequestEmailChangeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/request-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Email Change Otp
 *
 * Sends one of the two email-change codes again, without restarting the change. Pass `target: 'new'` to re-send the code to the new address or `target: 'current'` to re-send the one to the account’s current address, together with the `emailOtpToken` from the most recent `request-email-change` or resend — it identifies the change in progress, so the new address is not repeated in the body. Authenticated users only. Only the requested code changes: the previous code for that address stops working immediately, while the code sent to the other address keeps working. The `emailOtpToken` returned here replaces the one you sent and is the only one that pairs with the codes now outstanding — submit it to `confirm-email-change` together with both codes. Returns 401 when `emailOtpToken` is missing, expired, or was issued for a different flow. Returns 400 when the change is no longer resumable — because a code was already used, one of them expired or was superseded by a newer `request-email-change`, or `target: 'current'` was asked for an account that has no email yet — in which case start over at `request-email-change`; and when the account has meanwhile moved to the address the change was requested for. Returns 429 with `retryAfterSeconds` when a code was issued for that same address less than a minute ago, and nothing is sent or invalidated.
 */
export const postAuthResendEmailChangeOtp = <ThrowOnError extends boolean = true>(options: Options<PostAuthResendEmailChangeOtpData, ThrowOnError>) => (options.client ?? client).post<PostAuthResendEmailChangeOtpResponses, PostAuthResendEmailChangeOtpErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/resend-email-change-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Email Change
 *
 * Complete an email change for the authenticated user. Submit `newOtp` (the code sent to `newEmail`) and, when the account already has an email, also `currentOtp` (the code sent to the current address) — both must match to apply the change, switching the account to `newEmail` and marking it verified. Also submit `emailOtpToken`, the signed token returned by `request-email-change`: it binds the codes to that specific request, so a stale token from a previous send or a missing one is rejected without consuming either code. An account with no email yet confirms with `newOtp` alone and `currentOtp` is ignored; when that account was a guest, binding this email promotes it to a regular account — it is no longer a guest after this call succeeds. Authenticated users only; follows `request-email-change`. The codes are single-use and short-lived, so a wrong, expired, reused, missing, or mismatched code is rejected with 400 and the change is not applied. Returns 401 when `emailOtpToken` is missing, expired, or does not match the request. Returns 409 when the address was claimed by another account after the codes were requested. No new session is issued.
 */
export const postAuthConfirmEmailChange = <ThrowOnError extends boolean = true>(options: Options<PostAuthConfirmEmailChangeData, ThrowOnError>) => (options.client ?? client).post<PostAuthConfirmEmailChangeResponses, PostAuthConfirmEmailChangeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/confirm-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete User
 *
 * Permanently deletes the authenticated user's own account, resolved from the session. Authenticated users only; irreversible from the user's perspective. When the account has no verified email — anonymous accounts, social sign-ups with no address, or addresses not yet confirmed — deletion happens immediately and the response is `status: success`. When the account has a verified email, the first call (without `token`) emails a one-time code to that address and returns `status: requires_otp` together with an `emailOtpToken`; submit the same call again with the code as `token` and `emailOtpToken` echoed back to finalize. A missing or stale `emailOtpToken` is rejected with 401 without burning the code, so a legitimate retry with the right companion still succeeds. On `success` every session on the account is ended (including any admin impersonation session) and the session cookie is cleared, and every linked passkey and social account is released so the same email, passkey, or social identity can later be used to register a brand-new account. Returns 429 with `retryAfterSeconds` when this user requested a deletion code less than a minute ago.
 */
export const postAuthDeleteUser = <ThrowOnError extends boolean = true>(options: Options<PostAuthDeleteUserData, ThrowOnError>) => (options.client ?? client).post<PostAuthDeleteUserResponses, PostAuthDeleteUserErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/delete-user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Social Accounts
 *
 * List the social provider accounts (Google, X, Apple) currently linked to the authenticated user, oldest link first. Authenticated users only; never exposes another user's links or accounts that have been removed. Pairs with `unlink-social-account` for removal and with the social sign-in flow for adding new links.
 */
export const postAuthListSocialAccounts = <ThrowOnError extends boolean = true>(options: Options<PostAuthListSocialAccountsData, ThrowOnError>) => (options.client ?? client).post<PostAuthListSocialAccountsResponses, PostAuthListSocialAccountsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/list-social-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unlink Social Account
 *
 * Remove the link to the specified social `provider` (Google, Apple, X) on the authenticated user's account, so it can no longer be used to sign in. Authenticated users only. Idempotent and always succeeds when the provider was not linked to begin with — callers cannot probe which providers a user has connected. Refuses with 409 `last_social_account_without_email` when this would leave the account with no other linked social provider AND no email, because the account would no longer be reachable for sign-in; the same provider can be re-linked later via the social sign-in flow. List the currently linked providers with `list-social-accounts`.
 */
export const postAuthUnlinkSocialAccount = <ThrowOnError extends boolean = true>(options: Options<PostAuthUnlinkSocialAccountData, ThrowOnError>) => (options.client ?? client).post<PostAuthUnlinkSocialAccountResponses, PostAuthUnlinkSocialAccountErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/auth/unlink-social-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In As Guest
 *
 * Creates a throwaway guest account with no credentials and returns a new session, so a visitor can use the app without registering. Public; no authentication required, and it cannot be called while already signed in. Requires guest sign-in to be enabled on the server, otherwise the call is refused. Pass an optional `name` and `language` to seed the guest profile. The session is long-lived — a guest has no way to sign in again, so it stays valid for an extended period. The response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie.
 */
export const postAuthSignInAsGuest = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInAsGuestData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInAsGuestResponses, PostAuthSignInAsGuestErrors, ThrowOnError>({
    url: '/auth/sign-in-as-guest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Apple Mobile Ott
 *
 * Completes Apple Sign-In on a native mobile app via the one-time token (OTT) handed back through the device deep link. Public; no authentication required — the OTT is the proof of the just-completed Apple flow. Submit the `ott` from the deep link together with the original `state` value that started the flow. When the flow started with `intent: sign-in` (the default), the response carries `status: signed_in` plus the new session's bearer `token`, `csrfToken`, `expiresAt`, and the identity — branch on `status` before reading session fields. If the resolved account has multi-factor authentication enabled, no session is issued yet: the response is instead `status: requires_mfa` with a short-lived `mfaToken` and the `methods` you may use — complete one of them (e.g. `verify-totp`) to obtain the session. This is a mobile-only endpoint, so the challenge is returned in the body alone (no cookie). When the flow started with `intent: link`, the response carries `status: linked` and only the identity (no token / cookie is issued; the caller keeps its existing session). The OTT is single-use and short-lived: a reused, mismatched, or stale value is rejected.
 */
export const postAuthSignInWithAppleMobileOtt = <ThrowOnError extends boolean = true>(options: Options<PostAuthSignInWithAppleMobileOttData, ThrowOnError>) => (options.client ?? client).post<PostAuthSignInWithAppleMobileOttResponses, PostAuthSignInWithAppleMobileOttErrors, ThrowOnError>({
    url: '/auth/sign-in-with-apple-mobile-ott',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email
 *
 * Signs an existing back-office admin in with `email` and `password`. Public; no authentication required. Never creates an account — admins are invite-only. On success the response carries the new session (token, `csrfToken`, expiry), the admin, and the abilities granted to them; browsers also receive the session as a cookie. To avoid leaking which addresses are registered, an unknown email, a wrong password, and an admin with no password all return the same error. A disabled admin is rejected after the password is verified.
 */
export const postBackofficeAuthSignInWithEmail = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignInWithEmailData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignInWithEmailResponses, PostBackofficeAuthSignInWithEmailErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-in-with-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Sign In Otp
 *
 * Starts a passwordless sign-in: emails a one-time code to `email` when it belongs to an active admin, and returns a short-lived `emailOtpToken` to resend alongside the code at `sign-in-with-email-otp`. Public and invite-only — a code is sent only to a known admin, but the response is identical whether or not the address exists, so it can't be used to enumerate admins. Returns 429 with `retryAfterSeconds` when a code was issued for this address less than a minute ago.
 */
export const postBackofficeAuthSendSignInOtp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSendSignInOtpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSendSignInOtpResponses, PostBackofficeAuthSendSignInOtpErrors, ThrowOnError>({
    url: '/backoffice-auth/send-sign-in-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Email Otp
 *
 * Completes a passwordless sign-in with the `otp` from the email plus the `emailOtpToken` from `send-sign-in-otp`. Public; never creates an account — admins are invite-only, so a code for an unknown address can never be redeemed. On success the response carries the session, the admin, and the granted abilities; browsers also receive the session cookie.
 */
export const postBackofficeAuthSignInWithEmailOtp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignInWithEmailOtpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignInWithEmailOtpResponses, PostBackofficeAuthSignInWithEmailOtpErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-in-with-email-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Password Reset
 *
 * Starts an admin password reset. With `type: magic-link` a reset link is emailed; with `type: otp` a code is emailed and an `emailOtpToken` companion is returned. Public and enumeration-safe: the response is identical whether or not the address belongs to an admin, and nothing is emailed for an unknown address. Returns 429 with `retryAfterSeconds` when a reset was requested for this address less than a minute ago.
 */
export const postBackofficeAuthRequestPasswordReset = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthRequestPasswordResetData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthRequestPasswordResetResponses, PostBackofficeAuthRequestPasswordResetErrors, ThrowOnError>({
    url: '/backoffice-auth/request-password-reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 *
 * Completes an admin password reset with the token (`type: magic-link`) or the code plus `emailOtpToken` (`type: otp`) from `request-password-reset`, sets `newPassword`, and signs the admin straight in — the response carries the new session, admin, and abilities. The `otp` branch requires `emailOtpToken`: a missing/expired/mismatched one is rejected with 401 without burning the code, so a legitimate retry with the right token still succeeds; after five wrong attempts against the same code the code is revoked and a new one must be requested. The proof is single-use and cannot be replayed across methods (an OTP code is not accepted as a magic-link token, and vice-versa). `revokeOtherSessions` (default true) ends every other active session first. When two-factor is enabled the password is still rotated and other sessions still revoked, but the response is `status: requires_mfa` and no session is issued until a second factor clears. Public.
 */
export const postBackofficeAuthResetPassword = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthResetPasswordData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthResetPasswordResponses, PostBackofficeAuthResetPasswordErrors, ThrowOnError>({
    url: '/backoffice-auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Rotates the authenticated admin's password to `newPassword` after authorizing the change with one of three methods, discriminated by `type`, in a fixed priority: when two-factor is enabled the only accepted method is `type: "totp"` (a `deviceId` + authenticator `code`); otherwise, when a password is set, `type: "current-password"` re-confirms it; otherwise (passwordless admin with a verified email) `type: "otp"` after requesting a code via `send-change-password-otp`. A `type` that does not match the admin's current channel is rejected. By default other sessions are ended once the change succeeds; pass `revokeOtherSessions: false` to keep them. The current session is preserved, so no new token is issued. A passwordless admin with no verified email is rejected with `backoffice_no_change_password_method_available`.
 */
export const postBackofficeAuthChangePassword = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthChangePasswordData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthChangePasswordResponses, PostBackofficeAuthChangePasswordErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Change Password Otp
 *
 * Emails a single-use, time-limited code to the authenticated admin's verified email that authorizes a password change from inside an active session. The code is delivered to the address on file (none is taken from the request), valid for 5 minutes, single-use, and bound to the calling admin — submit it to `change-password` with `type: "otp"`. The response also carries the signed `emailOtpToken` companion the admin must echo back at `change-password` together with the typed code — without it the code is not redeemable. Requesting a new code invalidates any earlier one (and the matching `emailOtpToken` must come from the same call). Returns 400 when the admin has no verified email, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago.
 */
export const postBackofficeAuthSendChangePasswordOtp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSendChangePasswordOtpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSendChangePasswordOtpResponses, PostBackofficeAuthSendChangePasswordOtpErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/send-change-password-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Social Providers
 *
 * Returns the social-login providers ready for back-office sign-in, each with the public client configuration the frontend needs (provider identifier, public OAuth client ID, requested scopes). Public. A provider appears only when fully configured on the server, so the list reflects exactly which sign-in options to show. Back-office supports Google and Apple (authenticate-only).
 */
export const postBackofficeAuthGetSocialProviders = <ThrowOnError extends boolean = true>(options?: Options<PostBackofficeAuthGetSocialProvidersData, ThrowOnError>) => (options?.client ?? client).post<PostBackofficeAuthGetSocialProvidersResponses, PostBackofficeAuthGetSocialProvidersErrors, ThrowOnError>({ url: '/backoffice-auth/get-social-providers', ...options });

/**
 * Issue Social Native Nonce
 *
 * Issues a single-use, short-lived nonce for native social sign-in (Google / Apple). Public. Embed the `nonce` in the provider's on-device sign-in; the provider echoes it in the id_token, which `sign-in-with-google` / `sign-in-with-apple` verifies and consumes (anti-replay). Request a fresh nonce per attempt.
 */
export const postBackofficeAuthIssueSocialNativeNonce = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthIssueSocialNativeNonceData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthIssueSocialNativeNonceResponses, PostBackofficeAuthIssueSocialNativeNonceErrors, ThrowOnError>({
    url: '/backoffice-auth/issue-social-native-nonce',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Google
 *
 * Signs a back-office admin in with Google. Public, authenticate-only — never creates an account. Pass an authorization `code` from the web popup (`type: code`) or a native `token` id_token carrying a prior `issue-social-native-nonce` nonce (`type: token`). The Google identity must already belong to an active admin, or its verified email must match an invited admin (linked on this first sign-in); otherwise the call is rejected. On success the response carries the session, admin, and abilities.
 */
export const postBackofficeAuthSignInWithGoogle = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignInWithGoogleData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignInWithGoogleResponses, PostBackofficeAuthSignInWithGoogleErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-in-with-google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Apple
 *
 * Signs a back-office admin in with Apple using a native id_token that carries a prior `issue-social-native-nonce` nonce. Public, authenticate-only — never creates an account. The Apple identity must already belong to an active admin, or its verified email must match an invited admin (linked on this first sign-in); otherwise the call is rejected. On success the response carries the session, admin, and abilities.
 */
export const postBackofficeAuthSignInWithApple = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignInWithAppleData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignInWithAppleResponses, PostBackofficeAuthSignInWithAppleErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-in-with-apple',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Apple Mobile Ott
 *
 * Completes a native back-office Apple sign-in via the one-time token (OTT) handed back through the device deep link. Public — the OTT is the proof. Submit the `ott` and the original `state`. Single-use and short-lived; reused/mismatched/stale values are rejected. On success the response carries the session, admin, and abilities.
 */
export const postBackofficeAuthSignInWithAppleMobileOtt = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignInWithAppleMobileOttData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignInWithAppleMobileOttResponses, PostBackofficeAuthSignInWithAppleMobileOttErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-in-with-apple-mobile-ott',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Google Sign In Redirect
 *
 * Begins a back-office Google sign-in via browser redirect and returns the provider `url` to send the admin to. Pass the relative `callback`/`errorCallback` paths on the back-office frontend. Authenticate-only — the callback signs in an existing admin and never creates an account.
 */
export const postBackofficeAuthStartGoogleSignInRedirect = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthStartGoogleSignInRedirectData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthStartGoogleSignInRedirectResponses, PostBackofficeAuthStartGoogleSignInRedirectErrors, ThrowOnError>({
    url: '/backoffice-auth/start-google-sign-in-redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start Apple Sign In Redirect
 *
 * Begins a back-office Apple sign-in via browser redirect and returns the provider `url` to send the admin to. Pass the relative `callback`/`errorCallback` paths on the back-office frontend. Authenticate-only — the callback signs in an existing admin and never creates an account. Apple returns to the callback via `form_post`.
 */
export const postBackofficeAuthStartAppleSignInRedirect = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthStartAppleSignInRedirectData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthStartAppleSignInRedirectResponses, PostBackofficeAuthStartAppleSignInRedirectErrors, ThrowOnError>({
    url: '/backoffice-auth/start-apple-sign-in-redirect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Social Accounts
 *
 * Lists the social accounts linked to the authenticated admin, oldest first. Authenticated admins only.
 */
export const postBackofficeAuthListSocialAccounts = <ThrowOnError extends boolean = true>(options?: Options<PostBackofficeAuthListSocialAccountsData, ThrowOnError>) => (options?.client ?? client).post<PostBackofficeAuthListSocialAccountsResponses, PostBackofficeAuthListSocialAccountsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-social-accounts',
    ...options
});

/**
 * Unlink Social Account
 *
 * Removes the authenticated admin's link to the given social `provider`. Authenticated admins only. Idempotent — succeeds even when no such link exists. The admin can always still sign in with their password or via a reset, so no last-method guard applies.
 */
export const postBackofficeAuthUnlinkSocialAccount = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthUnlinkSocialAccountData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthUnlinkSocialAccountResponses, PostBackofficeAuthUnlinkSocialAccountErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/unlink-social-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Admin
 *
 * Invites a new back-office admin: creates the account (no password yet) with the given `abilities` and emails an invite link to set a password via `accept-invite`. Requires the `admins.manage` ability. Returns the created admin. Rejects a duplicate email with 409.
 */
export const postBackofficeAuthCreateAdmin = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthCreateAdminData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthCreateAdminResponses, PostBackofficeAuthCreateAdminErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/create-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept Invite
 *
 * Accepts an admin invite: sets the admin's `password` (and optional `name`), confirms the email, and signs them straight in — the response carries the session, admin, and abilities. Public; the invite `token` is the proof. A consumed, expired, or unknown token is rejected.
 */
export const postBackofficeAuthAcceptInvite = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthAcceptInviteData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthAcceptInviteResponses, PostBackofficeAuthAcceptInviteErrors, ThrowOnError>({
    url: '/backoffice-auth/accept-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Invite
 *
 * Re-sends the invite email to a pending admin (one who has not yet accepted). Requires the `admins.manage` ability. Rejects with 400 when the admin has already accepted (use the password reset flow instead) and 404 when no such admin exists.
 */
export const postBackofficeAuthResendInvite = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthResendInviteData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthResendInviteResponses, PostBackofficeAuthResendInviteErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/resend-invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Admins
 *
 * List back-office admins, one page at a time. Requires the `admins.manage` ability. Narrow results with `filters` (an explicit `ids` list to fetch a known set or a single admin, free-text `search` over name and email, an `abilities` set matched as any-of, a `disabled` state, and a derived lifecycle `status`) and order them with `sort`. Read `meta` for the total count and total page count, and request successive `page` values to page through the result. Deleted admins are never returned.
 */
export const postBackofficeAuthListAdmins = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthListAdminsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthListAdminsResponses, PostBackofficeAuthListAdminsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export Admins
 *
 * Export back-office admins using the same filters and sort supported by `list-admins`. Small exports can be downloaded synchronously; large exports are queued.
 */
export const postBackofficeAuthExportAdmins = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthExportAdminsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthExportAdminsResponses, PostBackofficeAuthExportAdminsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/export-admins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Exports :id
 *
 * Return the status of an async export requested by the signed-in admin. Completed exports include a short-lived download URL.
 */
export const getBackofficeAuthExportsId = <ThrowOnError extends boolean = true>(options: Options<GetBackofficeAuthExportsIdData, ThrowOnError>) => (options.client ?? client).get<GetBackofficeAuthExportsIdResponses, GetBackofficeAuthExportsIdErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/exports/{id}',
    ...options
});

/**
 * Update Admin Abilities
 *
 * Replace an admin's abilities with exactly the given set (any ability not listed is revoked). Requires the `admins.manage` ability. You cannot change your own abilities. Returns the updated admin.
 */
export const postBackofficeAuthUpdateAdminAbilities = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthUpdateAdminAbilitiesData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthUpdateAdminAbilitiesResponses, PostBackofficeAuthUpdateAdminAbilitiesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-admin-abilities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable Admin
 *
 * Disable an admin: blocks all sign-in and immediately ends every active session. Requires the `admins.manage` ability. You cannot disable your own account. Idempotent — disabling an already-disabled admin keeps the original disabled time. Returns the updated admin; re-enable with `enable-admin`.
 */
export const postBackofficeAuthDisableAdmin = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthDisableAdminData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthDisableAdminResponses, PostBackofficeAuthDisableAdminErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/disable-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Admin
 *
 * Re-enable a disabled admin so they can sign in again. Requires the `admins.manage` ability. Idempotent — enabling an already-active admin is a no-op. Returns the updated admin. Existing sessions stay revoked; the admin signs in afresh.
 */
export const postBackofficeAuthEnableAdmin = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthEnableAdminData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthEnableAdminResponses, PostBackofficeAuthEnableAdminErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/enable-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Admin
 *
 * Delete the admins in `ids` and return no content. Requires the `admins.manage` ability. Deleting an admin ends all their sessions and frees their email for re-invitation. You cannot delete your own account. All-or-nothing: if any id is unknown (or already deleted) nothing is deleted and the request is rejected.
 */
export const postBackofficeAuthDeleteAdmin = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthDeleteAdminData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthDeleteAdminResponses, PostBackofficeAuthDeleteAdminErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-admin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register Totp Authenticator
 *
 * Register a new TOTP authenticator for the authenticated admin and return the setup URI plus a manual-entry secret. Render `totpURI` as a QR code, or let the admin type `secret` by hand, then confirm the first generated code via `verify-totp-enrollment` to finish enrolling. There is a cap on devices per admin; enrolling beyond it returns 409.
 */
export const postBackofficeAuthRegisterTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthRegisterTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthRegisterTotpAuthenticatorResponses, PostBackofficeAuthRegisterTotpAuthenticatorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/register-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Totp Enrollment
 *
 * Confirm a just-registered authenticator by submitting the first `code` it shows for `deviceId` from `register-totp-authenticator`. On success the device is activated and two-factor authentication is enabled on the account. Returns 400 when the code is wrong or the short enrollment window has expired — restart enrollment via `register-totp-authenticator`. The submitted `code` is single-use; retrying for an already-confirmed device with the same in-window code still resolves successfully.
 */
export const postBackofficeAuthVerifyTotpEnrollment = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthVerifyTotpEnrollmentData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthVerifyTotpEnrollmentResponses, PostBackofficeAuthVerifyTotpEnrollmentErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/verify-totp-enrollment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Totp
 *
 * Verifies an authenticator `code` for the chosen `deviceId` during a sign-in MFA challenge and, on success, issues the session. Public; the challenge is identified by the `mfaToken` in the body. On a wrong code you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const postBackofficeAuthVerifyTotp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthVerifyTotpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthVerifyTotpResponses, PostBackofficeAuthVerifyTotpErrors, ThrowOnError>({
    url: '/backoffice-auth/verify-totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Backup Code
 *
 * Verifies a one-time backup `code` during a sign-in MFA challenge — the break-glass fallback when you cannot use your authenticator — and, on success, issues the session. Public; the challenge is identified by the `mfaToken` in the body. A wrong code may be retried with the same challenge until it is revoked after too many failed attempts. Each valid backup code works only once.
 */
export const postBackofficeAuthVerifyBackupCode = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthVerifyBackupCodeData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthVerifyBackupCodeResponses, PostBackofficeAuthVerifyBackupCodeErrors, ThrowOnError>({
    url: '/backoffice-auth/verify-backup-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Backup Codes
 *
 * Generate a fresh batch of single-use backup codes for the authenticated admin, invalidating any previously-issued unused codes. Admins only. Two-factor must already be active — enroll an authenticator via `register-totp-authenticator` + `verify-totp-enrollment` first, otherwise the call is rejected. The codes are returned in cleartext exactly once and cannot be retrieved later — present them immediately so the admin can store them. Use a code at `verify-backup-code` during a sign-in challenge.
 */
export const postBackofficeAuthGenerateBackupCodes = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthGenerateBackupCodesData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthGenerateBackupCodesResponses, PostBackofficeAuthGenerateBackupCodesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/generate-backup-codes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Totp Authenticators
 *
 * List the authenticated admin's own confirmed TOTP authenticators, one page at a time and ordered by most recent use, each with its friendly `name`, `verifiedAt`, and `lastUsedAt`. Never exposes another admin's devices, in-flight (unconfirmed) enrollments, or removed devices. Drives the rename (`update-totp-authenticator`) and removal (`delete-totp-authenticator`) actions.
 */
export const postBackofficeAuthListTotpAuthenticators = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthListTotpAuthenticatorsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthListTotpAuthenticatorsResponses, PostBackofficeAuthListTotpAuthenticatorsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-totp-authenticators',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Totp Authenticator
 *
 * Rename one of the authenticated admin's own confirmed TOTP authenticators. You can only update an authenticator you own that has already been confirmed via `verify-totp-enrollment`. Pass the device `id` and the new `name` — the response echoes the device in its updated form. Removing an authenticator is done via `delete-totp-authenticator`.
 */
export const postBackofficeAuthUpdateTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthUpdateTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthUpdateTotpAuthenticatorResponses, PostBackofficeAuthUpdateTotpAuthenticatorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Totp Authenticator
 *
 * Remove one of the authenticated admin's own TOTP authenticators, identified by `id`. Idempotent and always succeeds: removing a device that does not exist, is not yours, or is already removed returns success with no effect, so callers cannot probe which device ids exist. Removing the last verified device does not automatically turn off two-factor for the account — use `disable-two-factor` to do so explicitly.
 */
export const postBackofficeAuthDeleteTotpAuthenticator = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthDeleteTotpAuthenticatorData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthDeleteTotpAuthenticatorResponses, PostBackofficeAuthDeleteTotpAuthenticatorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-totp-authenticator',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable Two Factor
 *
 * Turn on two-factor authentication on the authenticated admin's account. Idempotent: calling on an already-enabled account succeeds with no effect. Raising this flag alone does not force a challenge at sign-in — the admin must also have at least one verified authenticator (enroll one via `register-totp-authenticator` + `verify-totp-enrollment`).
 */
export const postBackofficeAuthEnableTwoFactor = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthEnableTwoFactorData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthEnableTwoFactorResponses, PostBackofficeAuthEnableTwoFactorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/enable-two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Disable Two Factor
 *
 * Turn off two-factor authentication on the authenticated admin's account so future sign-ins no longer require a second factor. Authenticated admins only. Requires a second-factor step-up so a stolen session alone cannot disable MFA: pick a method via the discriminated `type` field. TOTP and passkey are the primary channels — either is accepted whenever the corresponding factor is enrolled. Recovery codes are accepted as single-use break-glass credentials from an authenticated session. Email OTP is the fallback and is only accepted when the account has neither a TOTP authenticator nor a passkey enrolled, and has a verified email on file; in that case obtain the code first via `send-disable-two-factor-otp`. A `type` that does not match the account's enrolled factors is rejected with `backoffice_disable_two_factor_method_not_available`. An account with none of (TOTP, passkey, verified email) needs no step-up — submit any supported `type` carrying a placeholder credential and the call still succeeds, since no second factor exists to challenge. Idempotent: calling on an already-disabled account still succeeds with no effect. Registered TOTP authenticators and recovery codes that were not used for this step-up are preserved, so the admin can re-enable later via `enable-two-factor` without re-enrolling.
 */
export const postBackofficeAuthDisableTwoFactor = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthDisableTwoFactorData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthDisableTwoFactorResponses, PostBackofficeAuthDisableTwoFactorErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/disable-two-factor',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Disable Two Factor Otp
 *
 * Emails a single-use, time-limited code to the authenticated admin's verified email address that authorizes disabling two-factor authentication from inside an active session. Authenticated admins only; the code is delivered to whatever address the account currently has on file, so no recipient is taken from the request. The code is 8 characters long, valid for 5 minutes, single-use, and bound to the calling account — pair it with `disable-two-factor` by submitting `type: "email-otp"` and the received code. The email-OTP channel is the fallback second factor reserved for accounts that have neither a TOTP authenticator nor a passkey enrolled; if you have either, this endpoint returns `backoffice_disable_two_factor_otp_unavailable` (400) and you must clear the step-up via `disable-two-factor` with `type: "totp"` or `type: "passkey"` instead. The same error is returned when the account has no verified email to deliver the code to. Requesting a new code invalidates any earlier code still outstanding for the same account. Returns 429 with `retryAfterSeconds` when another code was issued for this address less than a minute ago.
 */
export const postBackofficeAuthSendDisableTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSendDisableTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSendDisableTwoFactorOtpResponses, PostBackofficeAuthSendDisableTwoFactorOtpErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/send-disable-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Register Options
 *
 * Returns the WebAuthn options the authenticator needs to create a new passkey for the signed-in admin, together with a short-lived `passkeyToken`. Authenticated admins only — this enrolls an additional passkey, it does not sign anyone in. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `verify-passkey-registration` to finish enrollment. The authenticator is told about existing passkeys for this account so it refuses to enroll one already in use. Optionally constrain the authenticator type via `authenticatorAttachment`. Rejected with 409 when the account has reached the maximum number of registered passkeys — remove an existing passkey before enrolling a new one.
 */
export const postBackofficeAuthGeneratePasskeyRegisterOptions = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthGeneratePasskeyRegisterOptionsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthGeneratePasskeyRegisterOptionsResponses, PostBackofficeAuthGeneratePasskeyRegisterOptionsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/generate-passkey-register-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Passkey Registration
 *
 * Verifies the authenticator's response and registers the passkey on the signed-in admin's account. Authenticated admins only — this completes enrollment, it does not sign anyone in. Send the `response` produced by the authenticator together with the `passkeyToken` from `generate-passkey-register-options`; on success the new passkey becomes usable for passkey sign-in. Rejected with 409 when the account has reached the maximum number of registered passkeys — remove an existing passkey before enrolling a new one.
 */
export const postBackofficeAuthVerifyPasskeyRegistration = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthVerifyPasskeyRegistrationData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthVerifyPasskeyRegistrationResponses, PostBackofficeAuthVerifyPasskeyRegistrationErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/verify-passkey-registration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Passkeys
 *
 * List the authenticated admin's own passkeys, one page at a time and ordered by most recent use, each with its friendly `name`, device details, and `lastUsedAt`. Authenticated admins only; never exposes another admin's passkeys. Drives the rename (`update-passkey`) and removal (`delete-passkey`) actions.
 */
export const postBackofficeAuthListPasskeys = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthListPasskeysData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthListPasskeysResponses, PostBackofficeAuthListPasskeysErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-passkeys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Passkey
 *
 * Rename one of the authenticated admin's own passkeys. Authenticated admins only; you can only update a passkey you own. Pass the passkey `id` and the new `name` — the response echoes the passkey in its updated form. Use this to label multiple passkeys (e.g. 'MacBook Touch ID', 'YubiKey'). Removing a passkey is done via `delete-passkey`.
 */
export const postBackofficeAuthUpdatePasskey = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthUpdatePasskeyData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthUpdatePasskeyResponses, PostBackofficeAuthUpdatePasskeyErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Passkey
 *
 * Remove one of the authenticated admin's own passkeys, identified by `id`. Authenticated admins only. Idempotent and always succeeds: removing a passkey that does not exist, is not yours, or is already removed returns success with no effect, so callers cannot probe which passkey ids exist. Once removed the passkey can no longer be used to sign in; you can re-enroll the same authenticator later. List the available passkeys with `list-passkeys`.
 */
export const postBackofficeAuthDeletePasskey = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthDeletePasskeyData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthDeletePasskeyResponses, PostBackofficeAuthDeletePasskeyErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/delete-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Sign In Options
 *
 * Returns the WebAuthn options the authenticator needs to assert an existing passkey, together with a short-lived `passkeyToken`. Public; no authentication required — this starts a passkey sign-in. The options do not list which credentials exist on the server, so the client surfaces the platform's native credential selector and the server resolves the admin from whichever passkey the authenticator returns. User verification (biometric or PIN) is required for sign-in via passkey, so the assertion the authenticator returns must be user-verified; credentials that cannot perform UV remain usable as a second factor via `generate-passkey-step-up-options`. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `sign-in-with-passkey` to finish signing in.
 */
export const postBackofficeAuthGeneratePasskeySignInOptions = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthGeneratePasskeySignInOptionsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthGeneratePasskeySignInOptionsResponses, PostBackofficeAuthGeneratePasskeySignInOptionsErrors, ThrowOnError>({
    url: '/backoffice-auth/generate-passkey-sign-in-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign In With Passkey
 *
 * Completes a passkey sign-in by verifying the authenticator's assertion against a previously registered passkey. Public; no authentication required. Pairs with `generate-passkey-sign-in-options`, which mints the WebAuthn challenge and the matching `passkeyToken`. The token is single-use and expires shortly after it is issued, so a reused or stale challenge is rejected. The assertion must be user-verified — the authenticator collected a biometric or PIN — so a passkey signed in here satisfies multi-factor authentication on its own and the session is issued immediately, even when the account has MFA enabled. An assertion that only proved user presence (no verification, e.g. a security key without a PIN) is rejected; those credentials are still usable as a second factor via `verify-two-factor-passkey`. An unknown credential, a bad signature, and a counter rollback (cloned-key detection) all collapse to the same error so the endpoint cannot be used to probe which passkeys exist on the server. On success the response carries the session token and the `csrfToken` to attach to later mutating requests; browsers additionally receive the session as a cookie.
 */
export const postBackofficeAuthSignInWithPasskey = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignInWithPasskeyData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignInWithPasskeyResponses, PostBackofficeAuthSignInWithPasskeyErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-in-with-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Passkey Step Up Options
 *
 * Returns the WebAuthn options the authenticator needs to assert an existing passkey as a second factor, together with a short-lived `passkeyToken`. Public; no authentication required — this is called between a `requires_mfa` response and `verify-two-factor-passkey`. User verification is `preferred` (not `required`) on purpose: as an explicit second factor a passkey only needs to prove possession of a registered credential of the account, so a non-UV authenticator (e.g. a security key without a PIN) is still accepted — matching the semantics of `verify-two-factor-passkey`. The options do not list which credentials exist on the server, so the client surfaces the platform's native credential selector. The challenge is valid for a few minutes and is single-use: pass the resulting `passkeyToken` and the authenticator's response to `verify-two-factor-passkey` to clear the MFA challenge.
 */
export const postBackofficeAuthGeneratePasskeyStepUpOptions = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthGeneratePasskeyStepUpOptionsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthGeneratePasskeyStepUpOptionsResponses, PostBackofficeAuthGeneratePasskeyStepUpOptionsErrors, ThrowOnError>({
    url: '/backoffice-auth/generate-passkey-step-up-options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Two Factor Passkey
 *
 * Completes a sign-in MFA challenge with a passkey assertion and, on success, issues your session. Public; no authentication required. First call `generate-passkey-step-up-options` to obtain the WebAuthn options, assert the passkey, then send the `response` here. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. Any valid passkey assertion belonging to the account that started this sign-in clears the challenge — user verification (biometric / PIN) is NOT required when a passkey is used as a second factor, only possession of a registered credential. A passkey is NOT an available second factor when the first factor was itself a passkey: pairing the two would collapse both factors to a single credential or to mere possession of a registered credential, so the call is rejected — use TOTP or a recovery code instead. An assertion that belongs to a different account is rejected. On rejection you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const postBackofficeAuthVerifyTwoFactorPasskey = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthVerifyTwoFactorPasskeyData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthVerifyTwoFactorPasskeyResponses, PostBackofficeAuthVerifyTwoFactorPasskeyErrors, ThrowOnError>({
    url: '/backoffice-auth/verify-two-factor-passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Two Factor Otp
 *
 * Emails a one-time code as the second factor for an in-progress sign-in MFA challenge. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read — an invalid challenge is rejected. Email codes are only offered when you signed in with a password, your account has a verified email, and your account has neither a TOTP authenticator nor a passkey enrolled — email OTP is reserved as a fallback for admins without a stronger factor; if you have a TOTP authenticator or a passkey you must use those instead. After it succeeds, submit the code via `verify-two-factor-otp`. The code expires after a short window, and requesting a new one invalidates any earlier code still outstanding. Returns 429 with `retryAfterSeconds` when another code was requested less than a minute ago.
 */
export const postBackofficeAuthSendTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSendTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSendTwoFactorOtpResponses, PostBackofficeAuthSendTwoFactorOtpErrors, ThrowOnError>({
    url: '/backoffice-auth/send-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Two Factor Otp
 *
 * Verifies the one-time `code` emailed during a sign-in MFA challenge and, on success, issues your session. Public; no authentication required. The challenge is identified by the `mfaToken` in the body; the challenge cookie is never read. Request the code first via `send-two-factor-otp`. Email codes are only accepted as a second factor when you signed in with a password and your account has neither a TOTP authenticator nor a passkey enrolled — email OTP is reserved as a fallback for admins without a stronger factor; if you have a TOTP authenticator or a passkey you must use those instead. For a passwordless, social, or passkey sign-in the call is rejected. On a wrong code you may retry with the same challenge until it is revoked after too many failed attempts, after which you must sign in again.
 */
export const postBackofficeAuthVerifyTwoFactorOtp = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthVerifyTwoFactorOtpData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthVerifyTwoFactorOtpResponses, PostBackofficeAuthVerifyTwoFactorOtpErrors, ThrowOnError>({
    url: '/backoffice-auth/verify-two-factor-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Sessions
 *
 * List the authenticated admin's own sessions, one page at a time and ordered by most recent activity, each with its approximate location, device details, and lifecycle `status`. Never exposes another admin's sessions. Revoked and expired sessions stay in the list and are surfaced through `status`, while the session the request was made with is flagged by `isCurrent`. Pass `filters.status` to keep only sessions in a given lifecycle state. End any session with `revoke-session`.
 */
export const postBackofficeAuthListSessions = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthListSessionsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthListSessionsResponses, PostBackofficeAuthListSessionsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/list-sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Session
 *
 * Revoke the session identified by `sessionId`, signing out that device. Idempotent and always succeeds: revoking a session that does not exist, is not yours, or is already revoked returns success with no effect, so callers cannot probe which sessions exist. Revoking the session the call was made with immediately signs the caller out. List the available sessions with `list-sessions`.
 */
export const postBackofficeAuthRevokeSession = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthRevokeSessionData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthRevokeSessionResponses, PostBackofficeAuthRevokeSessionErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/revoke-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Email Change
 *
 * Start changing the authenticated admin's email to `newEmail` by sending a one-time code to that new address. If the admin already has an email, a second code is also sent to the current address and both are required to confirm. The codes are single-use and expire shortly after they are sent; submit them with `newEmail` and the `emailOtpToken` returned here to `confirm-email-change`. `currentEmailVerificationRequired` is true when a code was also sent to the current address. The response is uniform whether or not `newEmail` already belongs to another admin, so callers cannot enumerate addresses; an ownership clash is only surfaced at `confirm-email-change`. Returns 400 only when `newEmail` matches the current address, and 429 with `retryAfterSeconds` when a code was issued less than a minute ago for either address.
 */
export const postBackofficeAuthRequestEmailChange = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthRequestEmailChangeData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthRequestEmailChangeResponses, PostBackofficeAuthRequestEmailChangeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/request-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Email Change
 *
 * Complete an email change for the authenticated admin. Submit `newOtp` (the code sent to `newEmail`) and, when the admin already has an email, also `currentOtp` (the code sent to the current address) — both must match to switch the account to `newEmail` and mark it verified. Also submit `emailOtpToken` from `request-email-change`: it binds the codes to that request, so a stale or missing token is rejected without consuming either code. Codes are single-use and short-lived: a wrong, expired, reused, missing, or mismatched code is rejected with 400 and the change is not applied. Returns 401 when `emailOtpToken` is missing, expired, or does not match the request, and 409 when the address was claimed by another admin after the codes were requested. No new session is issued.
 */
export const postBackofficeAuthConfirmEmailChange = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthConfirmEmailChangeData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthConfirmEmailChangeResponses, PostBackofficeAuthConfirmEmailChangeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/confirm-email-change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 *
 * Return the authenticated admin's own profile (id, email, display name, avatar image, and whether two-factor is enabled) together with the `abilities` granted to them for client-side UI gating. Authenticated admins only; the account is resolved from the session. Use `update-me` to change the editable fields (name and avatar).
 */
export const postBackofficeAuthGetMe = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthGetMeData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthGetMeResponses, PostBackofficeAuthGetMeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/get-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Assets
 *
 * Register a new asset for the file described in `data` and return where to upload it. Admins only; the authenticated admin becomes the owner. The response carries an `upload` instruction describing exactly how to send the file bytes. Only the `admin_avatar` scope is accepted, and the request is rejected when `mimeType` is not allowed for it or `sizeInBytes` exceeds its limit. The asset stays pending until you attach it via `update-me`, so upload the file and reference the returned `id` promptly — unused assets are eventually discarded.
 */
export const postBackofficeAuthCreateAssets = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthCreateAssetsData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthCreateAssetsResponses, PostBackofficeAuthCreateAssetsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/create-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Me
 *
 * Update the authenticated admin's own profile and return the updated record. Admins only; the account is resolved from the session. Only `name` and `image` can be changed — fields you omit stay as they are. Pass `image` as an asset id from the asset upload flow, or null to clear the avatar. To change interface language or theme use `update-me-preferences`; to change your email use `request-email-change`; to change your password use `change-password`.
 */
export const postBackofficeAuthUpdateMe = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthUpdateMeData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthUpdateMeResponses, PostBackofficeAuthUpdateMeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Me Preferences
 *
 * Update the authenticated admin's interface preferences and return the updated values. Admins only; preferences are resolved from the session. Only `language` and `theme` can be changed — fields you omit stay as they are. The chosen `language` is the language of emails sent to this admin.
 */
export const postBackofficeAuthUpdateMePreferences = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthUpdateMePreferencesData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthUpdateMePreferencesResponses, PostBackofficeAuthUpdateMePreferencesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/backoffice-auth/update-me-preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Session
 *
 * Returns the caller's back-office auth context: `sessionType` is `unauthenticated` when no valid session is present and `authenticated` otherwise, with the `session`, `admin`, and `abilities` blocks populated. The `admin` block is the auth identity only (`id` and whether two-factor is enabled); fetch the full profile (email, name, avatar) via `get-me`. Public; works with or without credentials, so it is the endpoint to call on app start or after a reload to recover the signed-in state. When authenticated it also returns a fresh `csrfToken` for later mutating requests.
 */
export const postBackofficeAuthGetSession = <ThrowOnError extends boolean = true>(options?: Options<PostBackofficeAuthGetSessionData, ThrowOnError>) => (options?.client ?? client).post<PostBackofficeAuthGetSessionResponses, PostBackofficeAuthGetSessionErrors, ThrowOnError>({ url: '/backoffice-auth/get-session', ...options });

/**
 * Sign Out
 *
 * Ends a back-office session and clears the session cookie. Public and idempotent: pass the session's `token` in the body, or rely on the session cookie together with a valid `x-csrf-token` header. When no recognised credentials are present it is a no-op. Always succeeds.
 */
export const postBackofficeAuthSignOut = <ThrowOnError extends boolean = true>(options: Options<PostBackofficeAuthSignOutData, ThrowOnError>) => (options.client ?? client).post<PostBackofficeAuthSignOutResponses, PostBackofficeAuthSignOutErrors, ThrowOnError>({
    url: '/backoffice-auth/sign-out',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Checkout Session
 *
 * Create a Stripe-hosted Checkout session for one configured API subscription plan.
 */
export const postBillingCheckoutSession = <ThrowOnError extends boolean = true>(options: Options<PostBillingCheckoutSessionData, ThrowOnError>) => (options.client ?? client).post<PostBillingCheckoutSessionResponses, PostBillingCheckoutSessionErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing/checkout-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Portal Session
 *
 * Create a Stripe Customer Portal session to manage the current subscription, payment method, and Stripe invoices.
 */
export const postBillingPortalSession = <ThrowOnError extends boolean = true>(options?: Options<PostBillingPortalSessionData, ThrowOnError>) => (options?.client ?? client).post<PostBillingPortalSessionResponses, PostBillingPortalSessionErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing/portal-session',
    ...options
});

/**
 * Billing
 *
 * Return the API account subscription last synchronized from Stripe, or null for the free tier.
 */
export const getBilling = <ThrowOnError extends boolean = true>(options?: Options<GetBillingData, ThrowOnError>) => (options?.client ?? client).get<GetBillingResponses, GetBillingErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing',
    ...options
});

/**
 * Usage
 *
 * Return the authenticated API account plan, current limits, active API-key capacity, and monthly request quota usage.
 */
export const getBillingUsage = <ThrowOnError extends boolean = true>(options?: Options<GetBillingUsageData, ThrowOnError>) => (options?.client ?? client).get<GetBillingUsageResponses, GetBillingUsageErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing/usage',
    ...options
});

/**
 * Api Analytics Summary
 *
 * Return today's API request totals, success latency, errors, freshness, and authoritative monthly quota for the authenticated account.
 */
export const getBillingApiAnalyticsSummary = <ThrowOnError extends boolean = true>(options?: Options<GetBillingApiAnalyticsSummaryData, ThrowOnError>) => (options?.client ?? client).get<GetBillingApiAnalyticsSummaryResponses, GetBillingApiAnalyticsSummaryErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing/api-analytics/summary',
    ...options
});

/**
 * Api Analytics Timeseries
 *
 * Return API request metrics grouped for dashboard presets. Historical p95 values are approximated from fixed latency buckets.
 */
export const getBillingApiAnalyticsTimeseries = <ThrowOnError extends boolean = true>(options?: Options<GetBillingApiAnalyticsTimeseriesData, ThrowOnError>) => (options?.client ?? client).get<GetBillingApiAnalyticsTimeseriesResponses, GetBillingApiAnalyticsTimeseriesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing/api-analytics/timeseries',
    ...options
});

/**
 * Api Request Logs
 *
 * List recent API request logs for the authenticated account with structured filters and cursor pagination. Raw logs are retained for 30 days.
 */
export const getBillingApiRequestLogs = <ThrowOnError extends boolean = true>(options?: Options<GetBillingApiRequestLogsData, ThrowOnError>) => (options?.client ?? client).get<GetBillingApiRequestLogsResponses, GetBillingApiRequestLogsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/billing/api-request-logs',
    ...options
});

/**
 * Me
 *
 * Return the authenticated user's own profile, including display name, primary verified email, avatar image, and whether multi-factor authentication is enabled. Also reports `hasPassword` and `emailStatus` so the client can decide whether to offer "set password" or "change password", and whether the user must first add or verify an email before doing so. Authenticated users only; the account is always resolved from the session, so no payload is required. Use `PATCH /users/me` to change the editable fields.
 */
export const getUsersMe = <ThrowOnError extends boolean = true>(options?: Options<GetUsersMeData, ThrowOnError>) => (options?.client ?? client).get<GetUsersMeResponses, GetUsersMeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/users/me',
    ...options
});

/**
 * Me
 *
 * Update the authenticated user's own profile and return the updated record. Authenticated users only; the account is resolved from the session. `name`, `bio`, `image` (avatar) and `coverImage` can be changed — fields you omit stay as they are; `username` is set at signup and cannot be changed here. Pass `image`/`coverImage` as an asset id previously created via the asset upload flow, or null to clear it.
 */
export const patchUsersMe = <ThrowOnError extends boolean = true>(options: Options<PatchUsersMeData, ThrowOnError>) => (options.client ?? client).patch<PatchUsersMeResponses, PatchUsersMeErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Me Stats
 *
 * Return the authenticated user's collection statistics for their home/profile overview: total owned card copies, number of decks, number of wishlist items, catalog completion percent across all languages, and the estimated total market value of the collection in EUR. Authenticated users only; the account is resolved from the session, so no payload is required. Computed live on every call, so the figures always reflect the latest collection, deck, and wishlist state.
 */
export const getUsersMeStats = <ThrowOnError extends boolean = true>(options?: Options<GetUsersMeStatsData, ThrowOnError>) => (options?.client ?? client).get<GetUsersMeStatsResponses, GetUsersMeStatsErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/users/me/stats',
    ...options
});

/**
 * Me Preferences
 *
 * Return the authenticated user's interface preferences — preferred `language` and `theme`, plus the IANA timezone used for API analytics. Authenticated users only; preferences are resolved from the session. Sensible defaults (`en` language, `system` theme) are returned when the user has not set them yet. Use `PATCH /users/me/preferences` to change them.
 */
export const getUsersMePreferences = <ThrowOnError extends boolean = true>(options?: Options<GetUsersMePreferencesData, ThrowOnError>) => (options?.client ?? client).get<GetUsersMePreferencesResponses, GetUsersMePreferencesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/users/me/preferences',
    ...options
});

/**
 * Me Preferences
 *
 * Update the authenticated user's interface preferences and return the updated values. Authenticated users only; preferences are resolved from the session. Only `language`, `theme`, and `timeZone` can be changed — fields you omit stay as they are.
 */
export const patchUsersMePreferences = <ThrowOnError extends boolean = true>(options: Options<PatchUsersMePreferencesData, ThrowOnError>) => (options.client ?? client).patch<PatchUsersMePreferencesResponses, PatchUsersMePreferencesErrors, ThrowOnError>({
    security: [
        {
            in: 'cookie',
            name: 'x-session-token',
            type: 'apiKey'
        },
        { name: 'x-csrf-token', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' },
        {
            in: 'cookie',
            name: 'x-admin-session-token',
            type: 'apiKey'
        },
        { name: 'x-admin-csrf-token', type: 'apiKey' },
        {
            in: 'query',
            name: 'impersonateUserId',
            type: 'apiKey'
        }
    ],
    url: '/users/me/preferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Username Availability
 *
 * Check whether a `username` is available to claim during sign-up. Public; no authentication required. A malformed handle is rejected as a validation error; a well-formed one returns whether it is free. This is only a UX hint — uniqueness is ultimately enforced when the account is created, so a handle reported available can still be lost to a concurrent sign-up.
 */
export const getUsersUsernameAvailability = <ThrowOnError extends boolean = true>(options: Options<GetUsersUsernameAvailabilityData, ThrowOnError>) => (options.client ?? client).get<GetUsersUsernameAvailabilityResponses, GetUsersUsernameAvailabilityErrors, ThrowOnError>({ url: '/users/username-availability', ...options });

/**
 * Cards
 *
 * List physical card printings for API consumers. Requires an API key in `x-api-key`.
 */
export const getV1Cards = <ThrowOnError extends boolean = true>(options?: Options<GetV1CardsData, ThrowOnError>) => (options?.client ?? client).get<GetV1CardsResponses, GetV1CardsErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/cards',
    ...options
});

/**
 * Cards :id
 *
 * Fetch one physical card printing. Requires an API key in `x-api-key`.
 */
export const getV1CardsId = <ThrowOnError extends boolean = true>(options: Options<GetV1CardsIdData, ThrowOnError>) => (options.client ?? client).get<GetV1CardsIdResponses, GetV1CardsIdErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/cards/{id}',
    ...options
});

/**
 * Cards :id Prices
 *
 * List latest price series for a physical card printing. Requires an API key in `x-api-key`.
 */
export const getV1CardsIdPrices = <ThrowOnError extends boolean = true>(options: Options<GetV1CardsIdPricesData, ThrowOnError>) => (options.client ?? client).get<GetV1CardsIdPricesResponses, GetV1CardsIdPricesErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/cards/{id}/prices',
    ...options
});

/**
 * Sets :id Cards
 *
 * List physical card printings belonging to one set. Requires an API key in `x-api-key`.
 */
export const getV1SetsIdCards = <ThrowOnError extends boolean = true>(options: Options<GetV1SetsIdCardsData, ThrowOnError>) => (options.client ?? client).get<GetV1SetsIdCardsResponses, GetV1SetsIdCardsErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/sets/{id}/cards',
    ...options
});

/**
 * Sets
 *
 * List catalog sets. Requires an API key in `x-api-key`.
 */
export const getV1Sets = <ThrowOnError extends boolean = true>(options?: Options<GetV1SetsData, ThrowOnError>) => (options?.client ?? client).get<GetV1SetsResponses, GetV1SetsErrors, ThrowOnError>({
    security: [{ name: 'x-api-key', type: 'apiKey' }],
    url: '/v1/sets',
    ...options
});

/**
 * Health Check
 *
 * Returns the health check of the server
 */
export const getHealthCheck = <ThrowOnError extends boolean = true>(options?: Options<GetHealthCheckData, ThrowOnError>) => (options?.client ?? client).get<GetHealthCheckResponses, GetHealthCheckErrors, ThrowOnError>({ url: '/health-check', ...options });

/**
 * Services
 *
 * Returns the health check of the server services
 */
export const getHealthCheckServices = <ThrowOnError extends boolean = true>(options?: Options<GetHealthCheckServicesData, ThrowOnError>) => (options?.client ?? client).get<unknown, GetHealthCheckServicesErrors, ThrowOnError>({ url: '/health-check/services', ...options });

/**
 * Landing Metrics
 *
 * Return verified landing metrics. `catalogPrintings` counts card_printing rows. Request volume and latency cover the preceding 30 days and are calculated from 15-minute api_request_aggregate buckets. Responses are globally cached for 300 seconds; dataThrough is the latest aggregated request timestamp.
 */
export const getLandingMetrics = <ThrowOnError extends boolean = true>(options?: Options<GetLandingMetricsData, ThrowOnError>) => (options?.client ?? client).get<GetLandingMetricsResponses, GetLandingMetricsErrors, ThrowOnError>({ url: '/landing-metrics', ...options });
